import { atom } from "recoil";
import AsyncLocalStorage from "../utils/AsyncLocalStorage";
export const LANG_KO = 0;
export const LANG_EN = 1;
export const LANG_CH = 2;
export const LANG_JP = 3;
export const LANG_TH = 4;
export const LANG_ES = 5;
export const LANG_FR = 6;
export const LANG_RU = 7;
export const LANG_DE = 8;

export const getLangWord = (lang: number) => {
  switch (lang) {
    case LANG_KO:
      return "ko";
    case LANG_EN:
      return "en";
    case LANG_CH:
      return "ch";
    case LANG_JP:
      return "jp";
    case LANG_TH:
      return "th";
    case LANG_ES:
      return "es";
    case LANG_FR:
      return "fr";
    case LANG_RU:
      return "ru";
    case LANG_DE:
      return "de";
    default:
      return "ko";
  }
};

export const getLangName = (lang: number) => {
  switch (lang) {
    case LANG_KO:
      return "한국어";
    case LANG_EN:
      return "영어";
    case LANG_CH:
      return "중국어";
    case LANG_JP:
      return "일본어";
    case LANG_TH:
      return "태국어";
    case LANG_ES:
      return "스페인어";
    case LANG_FR:
      return "프랑스어";
    case LANG_RU:
      return "러시아어";
    case LANG_DE:
      return "독일어";
    default:
      return "한국어";
  }
};

type LangStringArrayType = [
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string
];

export const langState = atom<number>({
  key: "lang",
  default: LANG_KO,
  effects: [
    ({ setSelf, onSet }) => {
      const savedAuthData = AsyncLocalStorage.getItem("lang");

      if (savedAuthData) setSelf(savedAuthData);

      onSet((newValue, _, isReset) => {
        isReset
          ? AsyncLocalStorage.removeItem("lang")
          : AsyncLocalStorage.setItem("lang", JSON.stringify(newValue));
      });
    },
  ],
});

export const langText: Record<string, LangStringArrayType> = {
  // 공통
  call: [
    "긴급연락처",
    "Emergency Contact",
    "緊急聯絡人",
    "緊急連絡先",
    "ผู้ติดต่อฉุกเฉิน",
    "Contacto de Emergencia",
    "Contact d'Urgence",
    "Аварийный контакт",
    "Notfallkontakt",
  ],
  title_detail_count: ["개", "", "", "", "", "", "", "", ""],
  button_cancel: [
    "취소",
    "Cancel",
    "取消",
    "キャンセル",
    "ยกเลิก",
    "Cancelar",
    "Annuler",
    "Отменить",
    "Abbrechen",
  ],
  button_add_new: [
    "새로담기",
    "Add new",
    "新增",
    "新規追加",
    "เพิ่มใหม่",
    "Agregar nuevo",
    "Ajouter nouveau",
    "Добавить новый",
    "Neu hinzufügen",
  ],
  store_name: [
    "호텔",
    "HOTEL",
    "酒店",
    "ホテル",
    "โรงแรม",
    "Hotel",
    "Hôtel",
    "Отель",
    "Hotel",
  ],
  button_confirm: [
    "확인",
    "Confirm",
    "确认",
    "確認",
    "การยืนยัน",
    "Confirmar",
    "Confirmer",
    "Подтвердить",
    "Bestätigen",
  ],
  button_home: [
    "홈으로",
    "Home",
    "返回主页",
    "ホームへ",
    "กลับสู่หน้าหลัก",
    "Ir a inicio",
    "Aller à l'accueil",
    "На главную",
    "Zur Startseite",
  ],
  button_back: [
    "뒤로가기",
    "Go back",
    "返回",
    "戻る",
    "ย้อนกลับ",
    "Regresar",
    "Retourner",
    "Назад",
    "Zurück",
  ],
  minute: [
    "분",
    "m",
    "分钟",
    "分",
    "นาที",
    "minuto",
    "minute",
    "минута",
    "Minute",
  ],
  button_yes: ["네", "Yes", "是", "はい", "ใช่", "Sí", "Oui", "Да", "Ja"],
  button_no: [
    "아니오",
    "No",
    "不是",
    "いいえ",
    "ไม่",
    "No",
    "Non",
    "Нет",
    "Nein",
  ],
  total: [
    "총",
    "Total",
    "总",
    "合計",
    "ทั้งหมด",
    "Total",
    "Total",
    "Итого",
    "Gesamt",
  ],
  count: [
    "건",
    "Item(s)",
    "数量",
    "数量",
    "จำนวน",
    "Artículo(s)",
    "Élément(s)",
    "Количество",
    "Anzahl",
  ],
  open: [
    "영업",
    "Open from",
    "开放前",
    "営業中止",
    "เปิดร้าน",
    "Abierto",
    "Ouvert à partir de",
    "Открыто с",
    "Geöffnet von",
  ], // 변경필요
  pause: [
    "영업\n준비중",
    "Pause",
    "停业",
    "ロビー",
    "การระงับกิจการ",
    "Pausa",
    "Pause",
    "Приостановлено",
    "Pause",
  ],
  closed: [
    "마감",
    "Close at",
    "关闭前",
    "閉店まで",
    "ปิดร้าน",
    "Cerrar a",
    "Fermer à",
    "Закрыто в",
    "Schließen um",
  ],
  deadline: ["전", "", "钟", "前", "ก่อน", "antes", "avant", "до", "vor"],
  free_delivery: [
    "무료배달",
    "Free Delivery",
    "免费配送",
    "無料配達",
    "จัดส่งฟรี",
    "Entrega gratuita",
    "Livraison gratuite",
    "Бесплатная доставка",
    "Kostenlose Lieferung",
  ],
  coupon: [
    "할인쿠폰",
    "Discount Coupon",
    "优惠券",
    "割引クーポン",
    "คูปองส่วนลด",
    "Cupón de descuento",
    "Coupon de réduction",
    "Скидочный купон",
    "Rabattgutschein",
  ],
  discount: [
    "할인",
    "Discount",
    "折扣",
    "割引",
    "ส่วนลด",
    "Descuento",
    "Réduction",
    "Скидка",
    "Rabatt",
  ],
  tomorrow: [
    "내일",
    "Tomorrow",
    "明天",
    "明日",
    "พรุ่งนี้",
    "Mañana",
    "Demain",
    "Завтра",
    "Morgen",
  ],
  after_tomorrow: [
    "모레",
    "D+2",
    "后天",
    "あさって",
    "มะรืนนี้",
    "Pasado mañana",
    "Après-demain",
    "Послезавтра",
    "Übermorgen",
  ],
  at_door: [
    "문앞",
    "front of the door",
    "门前",
    "玄関",
    "หน้าประตู",
    "frente a la puerta",
    "devant la porte",
    "у двери",
    "vor der Tür",
  ],
  lobby: [
    "로비",
    "Lobby",
    "大厅",
    "ロビー",
    "ห้องโถง",
    "Vestíbulo",
    "Hall",
    "Лобби",
    "Empfangsbereich",
  ],
  firstFloorLobby: [
    "1층 로비",
    "1st floor lobby",
    "1楼大厅",
    "一階ロビー",
    "ล็อบบี้ชั้น 1",
    "Lobby del 1er piso",
    "Lobby du 1er étage",
    "Лобби 1-го этажа",
    "Lobby im 1. Stock",
  ],
  close: [
    "닫기",
    "Close",
    "关闭",
    "閉じる",
    "ปิด",
    "Cerrar",
    "Fermer",
    "Закрыть",
    "Schließen",
  ],
  delete: [
    "삭제",
    "Delete",
    "删除",
    "削除",
    "ลบ",
    "Eliminar",
    "Supprimer",
    "Удалить",
    "Löschen",
  ],

  room_tip: [
    "객실관리팁",
    "Room management tips",
    "客房管理小贴士",
    "客室管理のコツ",
    "เคล็ดลับการดูแลห้องพัก",
    "Consejos para la gestión de habitaciones",
    "Astuces pour la gestion des chambres",
    "Советы по управлению номерами",
    "Tipps zur Zimmerverwaltung",
  ],
  thanks: [
    "감사합니다.",
    "Thank you.",
    "谢谢。",
    "ありがとうございます。",
    "ขอบคุณครับ/ค่ะ.",
    "Gracias.",
    "Merci.",
    "Спасибо.",
    "Danke.",
  ],

  // 이벤트
  event_notice: [
    "당첨되신 쿠폰은 12시간 안에 사용해 주세요.",
    "Please use the winning coupon within 12 hours.",
    "中奖的优惠券请在12小时内使用。",
    "当選されたクーポンは12時間以内にお使いください。",
    "กรุณาใช้คูปองที่ได้รับเลือกภายใน 12 ชั่วโมงค่ะ",
    "Por favor, utiliza el cupón ganador dentro de las 12 horas.",
    "Veuillez utiliser le coupon gagnant dans les 12 heures.",
    "Пожалуйста, используйте выигрышный купон в течение 12 часов.",
    "Bitte verwenden Sie den Gewinncoupon innerhalb von 12 Stunden.",
  ],
  coupon_slider_notice: [
    "받고 지금 주문하세요!",
    "Get it and order it now!",
    "收到后现在订购吧！",
    "受け取ってから今注文してください！",
    "收到后现在订购吧！",
    "¡Recíbelo y ordena ahora!",
    "Recevez-le et commandez maintenant !",
    "Получите его и закажите сейчас!",
    "Holen Sie es ab und bestellen Sie jetzt!",
  ],
  coupon_view: [
    "쿠폰 보기",
    "View Coupons",
    "查看优惠券",
    "クーポンを見る",
    "แสดงคูปอง!",
    "Ver cupones",
    "Voir les coupons",
    "Посмотреть купоны",
    "Coupons anzeigen",
  ],
  prize: [
    "당첨",
    "Prize",
    "中奖",
    "当選",
    "การได้รับรางวัล",
    "Premio",
    "Prix",
    "Приз",
    "Preis",
  ],
  roulette_event: [
    "룰렛이벤트",
    "Roulette Event",
    "轮盘赌活动",
    "ルーレット·イベント",
    "เหตุการณ์รูเล็ตต์",
    "Evento de ruleta",
    "Événement roulette",
    "Событие рулетки",
    "Roulette-Event",
  ],
  roulette_coupon: [
    "까지 사용",
    "Use until ",
    "使用至 ",
    "まで使用",
    "ใช้จนถึง ",
    "Usar hasta ",
    "Utiliser jusqu’à ",
    "Использовать до ",
    "Verwendbar bis ",
  ],

  badge_new: [
    "신규입점",
    "NEW",
    "新入驻",
    "新規入店",
    "ใหม่",
    "Nuevo",
    "NOUVEAU",
    "Новый",
    "Neu",
  ],
  badge_high_rating: [
    "만족도 높은 매장",
    "High rating",
    "高评分",
    "高評価",
    "คะแนนสูง",
    "Tienda de alta calificación",
    "Évaluation élevée",
    "Высокий рейтинг",
    "Hohe Bewertung",
  ],
  badge_popluar: [
    "주문 많은 매장",
    "Popular",
    "非常受欢迎",
    "とても人気",
    "เป็นที่นิยมมาก",
    "Tienda popular",
    "Populaire",
    "Популярный",
    "Beliebt",
  ],
  kakaoTalk: [
    "카톡알림",
    "KAKAOTALK",
    "KAKAOTALK",
    "KAKAOTALK",
    "KAKAOTALK",
    "KAKAOTALK",
    "KAKAOTALK",
    "KAKAOTALK",
    "KAKAOTALK",
  ],

  // main_event_notice: [
  //   "체크인 시 받으신 할인쿠폰을 등록하고 사용해 보세요! 룰렛을 돌리고 최대 50% 할인쿠폰 받아가세요!",
  //   "Register and use the discount coupon you received at check-in! Spin the roulette and get up to 50% off coupons!",
  //   "登记入住时收到的优惠券后使用吧！ 转动转盘，领取最高50%的优惠券！",
  //   "チェックイン時にもらった割引クーポンを登録して使ってみてください！ ルーレットを回して最大50%の割引クーポンをもらって行ってください！",
  //   "ลงทะเบียนและใช้คูปองส่วนลดที่คุณได้รับเมื่อเช็คอิน! หมุนรูเล็ตต์ รับคูปองส่วนลดสูงสุด 50% ค่ะ!",
  // ],
  main_event_notice: [
    "룰렛을 돌리고 최대 50% 할인쿠폰 받아가세요!",
    "Spin the roulette and get up to 50% off coupons!",
    "转动转盘，领取最高50%的优惠券！",
    "ルーレットを回して最大50%の割引クーポンをもらって行ってください！",
    "หมุนรูเล็ตต์ รับคูปองส่วนลดสูงสุด 50% ค่ะ!",
    "¡Gira la ruleta y obtén cupones de hasta un 50% de descuento!",
    "Faites tourner la roulette et obtenez jusqu'à 50 % de réduction sur les coupons !",
    "Поверните рулетку и получите купоны со скидкой до 50 %!",
    "Drehen Sie das Roulette und erhalten Sie Coupons mit bis zu 50 % Rabatt!",
  ],

  // couponModal
  coupon_modal_title: [
    "노크노크 할인쿠폰 모아보기",
    "Collect Knock Knock Discount Coupons",
    "Knock Knock Knock 收集优惠券",
    "ノックノック 割引クーポン 集めてみる",
    "รวบรวมคูปองส่วนลด Knock Knock",
    "Recoge cupones de descuento Knock Knock",
    "Collecte des coupons de réduction Knock Knock",
    "Собирайте купоны на скидку Knock Knock",
    "Sammeln Sie Knock Knock Rabattgutscheine",
  ],
  coupon_modal_sub_title: [
    "메뉴를 장바구니에 담으시면 최대 할인으로 자동 적용돼요.",
    "If you put the menu in your shopping basket, it will be automatically applied with the maximum discount.",
    "把菜单放在购物车里的话，可以自动享受最大折扣。",
    "メニューをカートに入れると、最大割引で自動的に適用されます。",
    "หากคุณใส่เมนูลงในตะกร้าช้อปปิ้ง คุณจะได้รับส่วนลดสูงสุดโดยอัตโนมัติ",
    "Si pones el menú en tu carrito de compras, se aplicará automáticamente el descuento máximo.",
    "Si vous mettez le menu dans votre panier, il sera automatiquement appliqué avec la remise maximale.",
    "Если вы положите меню в свою корзину, максимальная скидка будет автоматически применена.",
    "Wenn Sie das Menü in Ihren Warenkorb legen, wird der maximale Rabatt automatisch angewendet.",
  ],
  min_price_notice: [
    "이상 주문 시 사용가능",
    "Available for more orders",
    "以上订购时可使用",
    "以上注文時に使用可能",
    "มีให้บริการเมื่อสั่งซื้อมากกว่า",
    "Disponible para pedidos superiores a",
    "Disponible pour les commandes supérieures à",
    "Доступно для заказов на сумму более",
    "Verfügbar für Bestellungen über",
  ],

  // content_name
  delivery_name: [
    "노크노크가 엄선한 배달맛집",
    "Top delivery favorites",
    "外卖必去餐厅",
    "デリバリー必須のレストラン",
    "ร้านอาหารสำหรับการส่งที่ต้องไป",
    "Favoritos de entrega seleccionados por Knock Knock",
    "Meilleures options de livraison",
    "Топ доставки",
    "Top-Lieferfavoriten",
  ],
  store_list: [
    "배달맛집 목록",
    "Store list",
    "商店列表",
    "店舗一覧",
    "รายการร้านค้า",
    "Lista de tiendas",
    "Liste des magasins",
    "Список магазинов",
    "Geschäftsliste",
  ],
  hotel_store: [
    "직영 매장",
    "Directly Operated Store",
    "直营店",
    "直営店",
    "ร้านสาขาตรง",
    "Tienda operada directamente",
    "Magasin exploité directement",
    "Магазин прямого управления",
    "Direkt betriebene Filiale",
  ],
  hotel_info: [
    "호텔 소개",
    "Hotel Overview",
    "酒店介绍",
    "ホテル紹介",
    "การแนะนำโรงแรม",
    "Descripción del hotel",
    "Aperçu de l'hôtel",
    "Информация о гостинице",
    "Hotelübersicht",
  ],
  coupon_name: [
    "쿠폰",
    "coupon",
    "优惠券",
    "クーポン",
    "คูปอง",
    "Cupón",
    "Coupon",
    "Купон",
    "Gutschein",
  ],
  today_recommendation: [
    "오늘의 추천",
    "Today's Pick",
    "今日推荐",
    "今日のおすすめ",
    "คำแนะนำวันนี้",
    "Recomendación de hoy",
    "Sélection du jour",
    "Рекомендация на сегодня",
    "Empfehlung des Tages",
  ],
  couple_recommendation: [
    "커플 추천",
    "Couples' Pick",
    "情侣推荐",
    "カップルおすすめ",
    "คำแนะนำสำหรับคู่รัก",
    "Recomendación para parejas",
    "Sélection pour les couples",
    "Рекомендация для пар",
    "Empfehlung für Paare",
  ],
  store_recommendation: [
    "우리가게 대표",
    "Store's Pick",
    "我们店的代表",
    "当店の代表",
    "ตัวแทนร้านของเรา",
    "Selección de nuestra tienda",
    "Sélection de notre magasin",
    "Выбор нашего магазина",
    "Auswahl unseres Geschäfts",
  ],
  store_situation: [
    "가게 사정",
    "Current store status",
    "店铺情况",
    "店舗状況",
    "สถานการณ์ร้าน",
    "Situación de la tienda",
    "État actuel du magasin",
    "Состояние магазина",
    "Aktueller Status des Geschäfts",
  ],
  customor_cancel: [
    "고객 취소",
    "Customer cancellation",
    "取消客户",
    "顧客キャンセル",
    "ยกเลิกลูกค้า",
    "Cancelación del cliente",
    "Annulation du client",
    "Отмена клиента",
    "Stornierung des Kunden",
  ],
  cooking_deliay: [
    "조리 지연",
    "Preparation delay",
    "烹饪延迟",
    "調理遅れ",
    "การเลื่อนการปรุงอาหาร",
    "Retraso en la preparación",
    "Délai de préparation",
    "Задержка в приготовлении",
    "Vorbereitungsverzögerung",
  ],
  request_unavailable: [
    "요청사항 적용 불가",
    "Request unavailable.",
    "请求不可用。",
    "リクエスト不可",
    "คำขอไม่สามารถใช้ได้",
    "Solicitud no disponible.",
    "Demande indisponible.",
    "Запрос недоступен.",
    "Anfrage nicht verfügbar.",
  ],
  delivery_Personnel_Absence: [
    "배달원 부재",
    "Delivery is unavailable.",
    "送货员缺席",
    "配達員不在",
    "ไม่มีพนักงานส่ง",
    "Falta de repartidor.",
    "Absence du livreur.",
    "Отсутствие курьера.",
    "Lieferdienst nicht verfügbar.",
  ],
  ingredients_exhausted: [
    "재료 소진",
    "Out of stock ingredients.",
    "原料耗尽",
    "材料切れ",
    "วัตถุดิบหมด",
    "Ingredientes agotados.",
    "Ingrédients en rupture de stock.",
    "Ингредиенты закончились.",
    "Zutaten erschöpft.",
  ],
  customer_request: [
    "고객 요청",
    "Customer inquiry",
    "客户要求",
    "お客様の要望",
    "คำขอของลูกค้า",
    "Solicitud del cliente.",
    "Demande du client.",
    "Запрос клиента.",
    "Kundenanfrage.",
  ],

  // back
  toast_back: [
    "장시간 움직임이 없어\n초기화면으로 이동했어요",
    "You are moved to the home screen due to inactivity.",
    "由于长时间不活动，\n移至初始屏幕",
    "長時間操作がないため、\n初期画面に移動しました",
    "เคลื่อนไปที่หน้าจอเริ่มต้น\nเนื่องจากไม่มีกิจกรรมเป็นเวลานาน",
    "Te has movido a la pantalla de inicio debido a la inactividad.",
    "Vous êtes déplacé vers l'écran d'accueil en raison de l'inactivité.",
    "Вы были перемещены на главный экран из-за бездействия.",
    "Sie wurden aufgrund von Inaktivität zum Startbildschirm verschoben.",
  ],
  toast_clerk: [
    "이용시간이 아니에요",
    "Outside of operating hours.",
    "这不是营业时间",
    "営業時間ではありません",
    "ไม่ใช่ช่วงเวลาที่ใช้บริการ",
    "Fuera del horario de atención.",
    "Hors des heures d'ouverture.",
    "Не в рабочее время.",
    "Außerhalb der Geschäftszeiten.",
  ],
  toast_time: [
    "이용시간",
    "Hours",
    "营业时间",
    "営業時間",
    "เวลาใช้บริการ",
    "Horas",
    "Heures",
    "Часы работы",
    "Öffnungszeiten",
  ],

  // conciergeModal
  conciergeModal_title: [
    "필요하신 요청사항을 선택해주세요",
    "Please select a request.",
    "请选择您需要的请求事项。",
    "必要なリクエストを選択してください",
    "กรุณาเลือกสิ่งที่ต้องการค่ะ",
    "Por favor, seleccione una solicitud.",
    "Veuillez sélectionner une demande.",
    "Пожалуйста, выберите запрос.",
    "Bitte wählen Sie eine Anfrage aus.",
  ],
  conciergeModal_button_clean: [
    "객실정비",
    "Room\ncleaning",
    "客房清理",
    "部屋の掃除",
    "ทำความสะอาดห้อง",
    "Limpieza de habitaciones",
    "Nettoyage de la chambre",
    "Уборка номера",
    "Zimmerreinigung",
  ],
  conciergeModal_button_water: [
    "생수",
    "Bottled\nwater",
    "瓶装水",
    "ボトル\nウォーター",
    "น้ำดื่มขวด",
    "Agua embotellada",
    "Eau en bouteille",
    "Бутылированная вода",
    "Flaschenwasser",
  ],
  conciergeModal_button_change: [
    "어매니티 교환",
    "Amenity\nexchange",
    "礼品互换",
    "アメニティの\n交換",
    "การแลกเปลี่ยน",
    "Intercambio de amenidades",
    "Échange d'amenités",
    "Обмен удобствами",
    "Austausch von Annehmlichkeiten",
  ],
  conciergeModal_button_towel: [
    "수건 교환",
    "Towel\nexchange",
    "毛巾交换",
    "タオルの交換",
    "การแลกเปลี่ยนผ้าขนหนู",
    "Intercambio de toallas",
    "Échange de serviettes",
    "Обмен полотенец",
    "Handtuchwechsel",
  ],
  conciergeModal_placeholder: [
    "요청사항을 적어주세요 (선택)",
    "Please write your request (optional).",
    "请写下您的请求（可选项）",
    "リクエストを書いてください（任意）",
    "กรุณาเขียนคำขอของคุณ (ไม่บังคับ)",
    "Por favor, escriba su solicitud (opcional).",
    "Veuillez écrire votre demande (facultatif).",
    "Пожалуйста, напишите свой запрос (по желанию).",
    "Bitte schreiben Sie Ihre Anfrage (optional).",
  ],
  conciergeModal_button_submit: [
    "요청하기",
    "Request",
    "请求",
    "リクエスト",
    "คำขอ",
    "Solicitar",
    "Demander",
    "Запрос",
    "Anfordern",
  ],

  // arrivalModal
  arrivalModal_title: [
    "배달 장소에 상품이 도착했어요.\n상품을 수령해주세요.",
    "Your order is ready for pickup at the delivery point.",
    "您的订单已到达交货点。\n请取货。",
    "配達ポイントにご注文が到着しました。\n商品を受け取ってください。",
    "คำสั่งของคุณมาถึงที่จัดส่งแล้ว\nโปรดรับสินค้าของคุณ",
    "Su pedido está listo para recoger en el punto de entrega.",
    "Votre commande est prête à être retirée au point de livraison.",
    "Ваш заказ готов к получению в пункте доставки.",
    "Ihre Bestellung ist zur Abholung am Lieferpunkt bereit.",
  ],
  arrivalModal_pickup: [
    "배달 장소",
    "Delivery point",
    "交货点",
    "配達ポイント",
    "จุดจัดส่ง",
    "Punto de entrega",
    "Point de livraison",
    "Пункт доставки",
    "Lieferpunkt",
  ],

  // orderCancelModal
  orderCancelModal_title: [
    "죄송해요. 주문이 취소되었어요.\n취소 사유를 확인하세요.",
    "I'm sorry, your order has been canceled.\nPlease check the reason for the cancellation.",
    "对不起。订单取消了。\n请确认取消原因",
    "申し訳ありません。注文がキャンセルされました。\nキャンセルの理由を確認してください。",
    "ขอโทษค่ะออเดอร์ถูกยกเลิกค่ะ\nโปรดตรวจสอบเหตุผลของการยกเลิกค่ะ",
    "Lo siento, su pedido ha sido cancelado.\nPor favor, verifique el motivo de la cancelación.",
    "Désolé, votre commande a été annulée.\nVeuillez vérifier la raison de l'annulation.",
    "Извините, ваш заказ был отменен.\nПожалуйста, проверьте причину отмены.",
    "Es tut mir leid, Ihre Bestellung wurde storniert.\nBitte überprüfen Sie den Grund für die Stornierung.",
  ],
  orderCancelModal_title_extension: [
    "죄송해요.\n객실연장이 취소되었어요",
    "Sorry,\nyour room extension has been canceled",
    "抱歉，\n您的客房延长已被取消",
    "申し訳ございません。\n客室延長がキャンセルされました",
    "ขออภัย\nการขยายเวลาห้องของคุณถูกยกเลิกแล้ว",
    "Lo siento,\ntu extensión de habitación ha sido cancelada",
    "Désolé,\nvotre prolongation de chambre a été annulée",
    "Извините,\nваше продление номера было отменено",
    "Es tut mir leid,\nIhre Zimmerverlängerung wurde storniert",
  ],
  orderCancelModal_reason: [
    "사유",
    "Reason",
    "原因",
    "理由",
    "เหตุผล",
    "Razón",
    "Raison",
    "Причина",
    "Grund",
  ],
  orderCancelModal_button_submit: [
    "자세히보기",
    "View details",
    "查看详情",
    "詳細を見る",
    "ดูรายละเอียด",
    "Ver detalles",
    "Voir les détails",
    "Посмотреть детали",
    "Details anzeigen",
  ],

  // ratingModal
  ratingModal_title: [
    "다음 고객을 위하여 남은 음식은\n깨끗하게 정리 및 환기 부탁드려요",
    "For the next customer,\nplease ventilate the room and tidy up any leftover food.",
    "为了下一次使用，\n请清理并通风剩余的食物",
    "次回の使用のために残りの食べ物は\nきれいに整理し、換気してください",
    "กรุณาทำความสะอาดและระบายอากาศ\nของอาหารที่เหลือเพื่อการใช้งานครั้งถัดไป",
    "Para el siguiente cliente,\npor favor ventile la habitación y limpie cualquier comida sobrante.",
    "Pour le prochain client,\nveuillez aérer la chambre et ranger les restes de nourriture.",
    "Для следующего клиента,\nпожалуйста, проветрите комнату и уберите остатки еды.",
    "Für den nächsten Kunden,\nbitte lüften Sie den Raum und räumen Sie übrig gebliebenes Essen auf.",
  ],
  ratingModal_title_rating: [
    "별점을 남겨주시면 큰 도움이 돼요",
    "For a better service, please provide us feedback.",
    "请您评价",
    "評価をお願いします",
    "โปรดให้คะแนน",
    "Por favor, déjenos su opinión.",
    "Veuillez nous donner votre avis.",
    "Пожалуйста, оставьте свой отзыв.",
    "Bitte geben Sie uns Ihr Feedback.",
  ],
  ratingModal_food_rating: [
    "음식만족도",
    "Food",
    "食物",
    "食べ物",
    "อาหาร",
    "Comida",
    "Nourriture",
    "Еда",
    "Essen",
  ],
  ratingModal_delivery_rating: [
    "배달만족도",
    "Delivery",
    "配送",
    "デリバリー",
    "การจัดส่ง",
    "Entrega",
    "Livraison",
    "Доставка",
    "Lieferung",
  ],
  ratingModal_placeholder: [
    "맛있게 드셨다면 리뷰를 남겨주세요 (선택)",
    "If you enjoyed your meal, consider leaving a review. (optional)",
    "如果您喜欢这顿饭，请留下您的评论（可选）",
    "おいしく召し上がったら、レビューをお願いします（任意）",
    "หากคุณรับประทานอาหารอร่อย กรุณาแสดงความคิดเห็น (ไม่บังคับ)",
    "Si disfrutó de su comida, considere dejar una reseña. (opcional)",
    "Si vous avez apprécié votre repas, pensez à laisser un avis. (facultatif)",
    "Если вам понравилась еда, оставьте отзыв. (по желанию)",
    "Wenn Ihnen Ihr Essen geschmeckt hat, hinterlassen Sie bitte eine Bewertung. (optional)",
  ],

  // orderHistory
  orderHistory_title: [
    "지난 주문 내역",
    "Order history",
    "过去的订单记录",
    "過去の注文履歴",
    "ประวัติการสั่งซื้อที่ผ่านมา",
    "Historial de pedidos",
    "Historique des commandes",
    "История заказов",
    "Bestellverlauf",
  ],
  orderHistory_nothing: [
    "지난 주문 내역이 없습니다",
    "No order history",
    "没有过去的订单记录",
    "過去の注文はありません",
    "ไม่มีประวัติการสั่งซื้อที่ผ่านมา",
    "No hay historial de pedidos",
    "Aucun historique de commandes",
    "Нет истории заказов",
    "Kein Bestellverlauf",
  ],

  // orderStatus
  orderStatus_button_history: [
    "주문내역",
    "Order history",
    "订单历史",
    "注文履歴",
    "ประวัติการสั่งซื้อ",
    "Historial de pedidos",
    "Historique des commandes",
    "История заказов",
    "Bestellverlauf",
  ],
  orderStatus_order_index: [
    "번째 주문",
    "Order no.",
    "号订单",
    "番目の注文",
    "คำสั่งซื้อที่",
    "Pedido n.º",
    "Commande n°",
    "Заказ №",
    "Bestellung Nr.",
  ],
  orderStatus_remainTime: [
    "남은 시간",
    "Remaining time",
    "剩余时间",
    "残り時間",
    "เวลาที่เหลือ",
    "Tiempo restante",
    "Temps restant",
    "Оставшееся время",
    "Verbleibende Zeit",
  ],
  orderStatus_arrived: [
    "도착완료",
    "Arrived",
    "到达完成",
    "到着完了",
    "มาถึงแล้ว",
    "Llegado",
    "Arrivé",
    "Прибыл",
    "Angekommen",
  ],
  orderStatus_arrived_sms: [
    "예약 확정",
    "",
    "到达完成",
    "到着完了",
    "มาถึงแล้ว",
    "Llegado",
    "Arrivé",
    "Прибыл",
    "Angekommen",
  ],
  orderStatus_processing: [
    "주문 확인중",
    "Processing",
    "确认中",
    "処理中",
    "กำลังดำเนินการ",
    "Procesando",
    "Traitement en cours",
    "Обрабатывается",
    "Wird bearbeitet",
  ],
  orderStatus_exceed: [
    "초과",
    "Exceeded",
    "超过",
    "超過",
    "เกิน",
    "Excedido",
    "Dépassé",
    "Превышено",
    "Überschritten",
  ],
  orderStatus_title_checking: [
    "주문을 확인하고 있어요",
    "Order confirmation in progress",
    "正在检查订单",
    "注文を確認中",
    "กำลังตรวจสอบคำสั่งซื้อ",
    "Confirmación de pedido en curso",
    "Confirmation de commande en cours",
    "Подтверждение заказа в процессе",
    "Bestellbestätigung läuft",
  ],
  orderStatus_title_confirm: [
    "매장에서 주문을 접수했어요",
    "Order received successfully",
    "订单已接收",
    "ご注文を受け付けました",
    "คำสั่งซื้อของคุณได้รับแล้ว",
    "Pedido recibido con éxito",
    "Commande reçue avec succès",
    "Заказ успешно получен",
    "Bestellung erfolgreich erhalten",
  ],
  orderStatus_title_cooking: [
    "음식을 정성껏 조리중이에요",
    "Food preparation underway",
    "美味的食物正在烹饪中",
    "美味しい料理の調理中です",
    "กำลังทำอาหารอร่อยของคุณ",
    "La preparación de alimentos está en curso",
    "La préparation des aliments est en cours",
    "Приготовление пищи в процессе",
    "Die Zubereitung von Speisen ist im Gange",
  ],
  orderStatus_title_cooked: [
    "조리가 완료되었어요",
    "Cooked",
    "烹饪完成",
    "調理が完了しました",
    "การทำอาหารเสร็จสมบูรณ์",
    "Cocinado",
    "Cuit",
    "Приготовлено",
    "Gekocht",
  ],
  orderStatus_title_delivery: [
    "음식을 안전하게 배달중이에요",
    "Delivery in progress",
    "正在安全地配送您的餐点",
    "おいしい料理を安全に配達中です",
    "กำลังจัดส่งอาหารของคุณอย่างปลอดภัย",
    "Entrega en curso",
    "Livraison en cours",
    "Доставка в процессе",
    "Lieferung läuft",
  ],
  orderStatus_title_complete: [
    "음식이 도착했어요",
    "Delivery completed",
    "食物已送达",
    "料理が到着しました",
    "อาหารถึงแล้ว",
    "Entrega completada",
    "Livraison terminée",
    "Доставка завершена",
    "Lieferung abgeschlossen",
  ],
  orderStatus_title_cancel: [
    "주문이 취소되었어요",
    "Your order is cancelled.",
    "订单已取消",
    "注文がキャンセルされました",
    "การสั่งซื้อถูกยกเลิกแล้ว",
    "Su pedido ha sido cancelado.",
    "Votre commande a été annulée.",
    "Ваш заказ отменен.",
    "Ihre Bestellung wurde storniert.",
  ],
  orderStatus_title_preparing_rental: [
    "상품을 준비중이에요",
    "Product is being prepared",
    "商品正在准备中",
    "商品を準備中です",
    "สินค้ากำลังเตรียมการ",
    "El producto se está preparando",
    "Le produit est en cours de préparation",
    "Продукт готовится",
    "Das Produkt wird vorbereitet",
  ],
  orderStatus_title_delivery_rental: [
    "상품을 전달중이에요",
    "Delivery in progress",
    "商品正在传达中",
    "商品をお届け中です",
    "สินค้ากำลังถูกส่งมอบ",
    "La entrega del producto está en curso",
    "La livraison du produit est en cours",
    "Доставка продукта в процессе",
    "Die Lieferung des Produkts ist im Gange",
  ],
  orderStatus_title_complete_rental: [
    "상품을 전달 완료했어요",
    "Delivery completed",
    "商品已送达",
    "商品が届しました",
    "สินค้ามาถึงแล้ว",
    "La entrega del producto se ha completado",
    "La livraison du produit est terminée",
    "Доставка продукта завершена",
    "Die Lieferung des Produkts ist abgeschlossen",
  ],

  orderStatus_title_complete_sms: [
    "예약이 확정되었어요. 입력하신 연락처로\n보내드린 예약정보를 확인해주세요",
    "Reservation completed. Please check the details sent to your contact",
    "预订已完成。请检查已发送到您的联系方式上的预约信息",
    "予約が完了しました。連絡先に送信した予約情報をご確認ください",
    "การจองเสร็จสมบูรณ์แล้ว กรุณาตรวจสอบข้อมูลการจองที่ส่งไปยังข้อมูลติดต่อของคุณ",
    "La reserva se ha completado. Por favor, verifique los detalles enviados a su contacto",
    "La réservation est terminée. Veuillez vérifier les détails envoyés à votre contact",
    "Бронирование завершено. Пожалуйста, проверьте детали, отправленные на ваш контакт",
    "Die Reservierung ist abgeschlossen. Bitte überprüfen Sie die an Ihren Kontakt gesendeten Details",
  ],

  orderStatus_content_cancel: [
    "현재 배달이 어려워요\n죄송하지만 다른 매장 이용 부탁드립니다",
    "Apologies, delivery is currently unavailable from this store. Please consider another store.",
    "当前配送困难。\n抱歉，请使用其他商店。",
    "現在、配達が困難です。\n申し訳ありませんが、他の店舗をご利用ください。",
    "การจัดส่งยากขึ้นในขณะนี้\nขอโทษค่ะ กรุณาใช้ร้านอื่น",
    "Lo sentimos, la entrega no está disponible actualmente desde esta tienda. Por favor, considere otra tienda.",
    "Désolé, la livraison n'est actuellement pas disponible depuis ce magasin. Veuillez envisager un autre magasin.",
    "Извините, доставка в данный момент недоступна из этого магазина. Пожалуйста, рассмотрите возможность использования другого магазина.",
    "Entschuldigung, die Lieferung ist derzeit in diesem Geschäft nicht verfügbar. Bitte ziehen Sie ein anderes Geschäft in Betracht.",
  ],
  orderStatus_content_cancel_other: [
    "현재 주문이 어려워요\n죄송하지만 다른 매장 이용 부탁드립니다",
    "Apologies, orders are unavailable. Please consider another store.",
    "无法下单。\n抱歉，请使用其他商店。",
    "ご注文はできません。\n申し訳ありませんが、他の店舗をご利用ください。",
    "ขออภัย ไม่สามารถสั่งซื้อได้\nกรุณาพิจารณาใช้ร้านค้าอื่น",
    "Lo sentimos, los pedidos no están disponibles. Por favor, considere otra tienda.",
    "Désolé, les commandes ne sont pas disponibles. Veuillez envisager un autre magasin.",
    "Извините, заказы в данный момент недоступны. Пожалуйста, рассмотрите возможность использования другого магазина.",
    "Entschuldigung, Bestellungen sind derzeit nicht verfügbar. Bitte ziehen Sie ein anderes Geschäft in Betracht.",
  ],
  orderStatus_button_cancelled: [
    "취소 완료",
    "Cancelled",
    "取消完成",
    "キャンセル",
    "ยกเลิก",
    "Cancelado",
    "Annulé",
    "Отменен",
    "Storniert",
  ],
  orderStatus_status_confirm: [
    "주문확인",
    "Confirmed",
    "订单确认",
    "注文確認",
    "ยืนยัน",
    "Confirmado",
    "Confirmé",
    "Подтверждено",
    "Bestätigt",
  ],
  orderStatus_button_cooking: [
    "조리중",
    "Cooking",
    "烹饪中",
    "調理中",
    "กำลังทำอาหาร",
    "Cocinando",
    "En cours de cuisson",
    "Готовится",
    "Kochen",
  ],
  orderStatus_button_cooked: [
    "조리완료",
    "Cooked",
    "烹饪完成",
    "調理完了",
    "สมบูรณ์",
    "Cocinado",
    "Cuit",
    "Приготовлено",
    "Gekocht",
  ],
  orderStatus_button_delivery: [
    "배달중",
    "In delivery",
    "配送中",
    "デリバリー中",
    "กำลังจัดส่ง",
    "En entrega",
    "En cours de livraison",
    "В доставке",
    "In der Lieferung",
  ],
  orderStatus_button_complete: [
    "배달완료",
    "Completed",
    "配送完成",
    "デリバリー完了",
    "เสร็จสิ้น",
    "Completado",
    "Terminé",
    "Завершено",
    "Abgeschlossen",
  ],
  orderStatus_button_cancel: [
    "주문취소",
    "Cancelled",
    "取消",
    "キャンセル",
    "ยกเลิก",
    "Cancelar",
    "Annuler",
    "Отменить",
    "Stornieren",
  ],
  orderStatus_button_preparing_rental: [
    "상품 준비중",
    "Preparing",
    "准备中",
    "準備中",
    "กำลังเตรียมการ",
    "Preparando",
    "Préparation en cours",
    "Подготовка",
    "Vorbereitung",
  ],
  orderStatus_button_delivery_rental: [
    "전달중",
    "In delivery",
    "传达中",
    "伝達中",
    "กำลังส่งมอบ",
    "En entrega",
    "En cours de livraison",
    "В доставке",
    "In der Lieferung",
  ],
  orderStatus_button_complete_rental: [
    "전달완료",
    "Completed",
    "已传达",
    "伝達完了",
    "เสร็จสิ้น",
    "Entregado",
    "Livré",
    "Доставлено",
    "Zugestellt",
  ],
  orderStatus_button_complete_sms: [
    "예약 확정",
    "Completed",
    "配送完成",
    "デリバリー完了",
    "เสร็จสิ้น",
    "Reserva confirmada",
    "Terminé",
    "Завершено",
    "Abgeschlossen",
  ],

  orderStatus_button_order: [
    "추가 주문하기",
    "Add to order",
    "加入订单",
    "注文に追加",
    "เพิ่มลงในคำสั่งซื้อ",
    "Agregar al pedido",
    "Ajouter à la commande",
    "Добавить к заказу",
    "Zur Bestellung hinzufügen",
  ],
  order_cancel_notice: [
    "조리가 시작되어\n취소가 불가능합니다",
    "It is impossible to cancel\n because cooking has started.",
    "烹饪开始了\n不能取消。",
    "調理が始まるため\nキャンセルはできません。",
    "การปรุงอาหารเริ่มขึ้นและไม่สามารถยกเลิกได้",
    "La cocción ha comenzado\nno se puede cancelar.",
    "La cuisson a commencé\nil n'est pas possible d'annuler.",
    "Приготовление начато\nотменить невозможно.",
    "Das Kochen hat begonnen\nStornierung ist nicht möglich.",
  ],

  // storeSelector
  storeSelector_button_closed: [
    "영업종료",
    "CLOSED",
    "营业结束",
    "営業終了",
    "ปิดทำการ",
    "CERRADO",
    "FERMÉ",
    "ЗАКРЫТО",
    "GESCHLOSSEN",
  ],
  storeSelector_badge_late_night: [
    "심야식당",
    "Late-night eatery",
    "深夜餐厅",
    "深夜食堂",
    "ร้านอาหารกลางคืน",
    "Comida nocturna",
    "Restaurant de nuit",
    "Ночной ресторан",
    "Nachtlokal",
  ],
  storeSelector_badge_breakfast: [
    "조식",
    "Breakfast",
    "早餐",
    "朝食",
    "อาหารเช้า",
    "Desayuno",
    "Petit-déjeuner",
    "Завтрак",
    "Frühstück",
  ],
  storeSelector_button_menu: [
    "매장 바로가기",
    "Go to store",
    "直达商店",
    "店舗へアクセス",
    "ไปที่ร้าน",
    "Ir a la tienda",
    "Aller au magasin",
    "Перейти в магазин",
    "Zum Geschäft gehen",
  ],
  storeSelector_open: [
    "오픈",
    "OPEN",
    "打开",
    "オープン",
    "เปิด",
    "Abrir",
    "Ouvrir",
    "Открыть",
    "Öffnen",
  ],

  storeSelector_directlyTitle: [
    "직영 서비스",
    "'s Direct service",
    "的直营服务",
    "の直営サービス",
    "บริการตรง",
    " Servicio directo",
    " Service direct",
    " Прямое обслуживание",
    " Direktservice",
  ],
  storeSelector_turnOff: [
    "화면끄기",
    "Sleep",
    "关闭",
    "オフ",
    "ปิด",
    "Apagar",
    "Éteindre",
    "Выключить",
    "Ausschalten",
  ],
  storeSelector_orderStatus: [
    "주문내역",
    "Order history",
    "订单历史",
    "注文履歴",
    "ประวัติการสั่งซื้อ",
    "Historial de pedidos",
    "Historique des commandes",
    "История заказов",
    "Bestellverlauf",
  ],

  // confirmModal
  confirmModal_title: [
    "요청이 완료되었어요",
    "Request completed",
    "请求已完成",
    "リクエストが完了しました",
    "คำขอเสร็จสมบูรณ์",
    "La solicitud ha sido completada",
    "Demande terminée",
    "Запрос завершен",
    "Anfrage abgeschlossen",
  ],
  confirmModal_cart: [
    "장바구니에 메뉴를 담아주세요",
    "Please add an item to the cart",
    "请将菜单加入购物车",
    "カートにメニューを追加してください",
    "โปรดเพิ่มเมนูลงในตะกร้า",
    "Por favor, añade un artículo al carrito",
    "Veuillez ajouter un article au panier",
    "Пожалуйста, добавьте товар в корзину",
    "Bitte fügen Sie einen Artikel zum Warenkorb hinzu",
  ],
  confirmModal_closed: [
    "영업이 종료되었어요",
    "Business hours have ended",
    "营业已结束",
    "営業が終了しました",
    "เวลาทำการสิ้นสุดแล้ว",
    "Las horas de negocio han terminado",
    "Les heures d'ouverture sont terminées",
    "Часы работы завершены",
    "Die Geschäftszeiten sind beendet",
  ],
  confirmModal_alcohol: [
    "주류는 만 19세 이상만 주문할 수 있어요\n배달기사님께 신분증을 보여주세요",
    "You must be 19 or older to order alcohol beverage.\nPlease show your identification when you pick up your order.",
    "酒类只能由成人订购\n请出示您的身份证明。",
    "お酒は大人のみ注文できます\n身分証をご提示ください。",
    "เหล้าสามารถสั่งได้เฉพาะผู้ใหญ่\nโปรดแสดงบัตรประจำตัว",
    "Solo pueden pedir bebidas alcohólicas quienes tengan 19 años o más.\nPor favor, muestre su identificación al recoger su pedido.",
    "Vous devez avoir 19 ans ou plus pour commander de l'alcool.\nVeuillez montrer votre pièce d'identité lors de la collecte de votre commande.",
    "Алкоголь могут заказывать только лица старше 19 лет.\nПожалуйста, покажите ваше удостоверение личности при получении заказа.",
    "Alkohol darf nur von Personen über 19 Jahren bestellt werden.\nBitte zeigen Sie Ihren Ausweis, wenn Sie Ihre Bestellung abholen.",
  ],
  confirmModal_cart_reset: [
    "장바구니에 담긴 상품이\n모두 사라져요",
    "All items in the cart will be removed.",
    "购物车中的所有商品都将消失",
    "カートに入っているすべての商品が消えます",
    "สินค้าทั้งหมดในตะกร้าจะหายไป",
    "Se eliminarán todos los artículos del carrito.",
    "Tous les articles du panier seront supprimés.",
    "Все товары в корзине будут удалены.",
    "Alle Artikel im Warenkorb werden entfernt.",
  ],
  confirmModal_cancelPayment: [
    "결제를 취소할까요?",
    "Cancel the payment?",
    "是否取消支付？",
    "支払いをキャンセルしますか？",
    "คุณต้องการยกเลิกการชำระเงินหรือไม่?",
    "¿Cancelar el pago?",
    "Annuler le paiement ?",
    "Отменить платеж?",
    "Zahlung stornieren?",
  ],
  // productDetailModla
  productDetailModal_title: [
    "상세 설명",
    "Detailed description",
    "详细说明",
    "詳細な説明",
    "คำอธิบายอย่างละเอียด",
    "Descripción detallada",
    "Description détaillée",
    "Подробное описание",
    "Detaillierte Beschreibung",
  ],

  // responseModal
  responseModal_title: [
    "답변이 도착했어요",
    "Response received",
    "答复已到达",
    "回答が届きました",
    "ได้รับการตอบกลับ",
    "Respuesta recibida",
    "Réponse reçue",
    "Ответ получен",
    "Antwort erhalten",
  ],
  responseModal_sub_title: [
    "필요한 것이 있으시면 언제든지 요청해주세요",
    "If you need anything, please feel free to ask",
    "有什么需要请随时提出来",
    "必要なものがありましたらいつでもリクエストしてください",
    "หากต้องการอะไรกรุณาติดต่อมาได้ตลอดเวลาค่ะ",
    "Si necesitas algo, no dudes en pedirlo",
    "Si vous avez besoin de quoi que ce soit, n'hésitez pas à demander",
    "Если вам что-то нужно, пожалуйста, не стесняйтесь спрашивать",
    "Wenn Sie etwas benötigen, fragen Sie bitte jederzeit",
  ],
  responseModal_badge_complete: [
    "응답했다",
    "Responded",
    "已回复",
    "応答した",
    "ตอบแล้ว",
    "Respondió",
    "A répondu",
    "Ответил",
    "Hat geantwortet",
  ],
  responseModal_button_check: [
    "확인하고 삭제하기",
    "Check and delete",
    "确认并删除",
    "確認して削除",
    "ตรวจสอบและลบ",
    "Verificar y eliminar",
    "Vérifier et supprimer",
    "Проверить и удалить",
    "Überprüfen und löschen",
  ],

  responseModal_badge_comment: [
    "고객님의 소중한 사생활 보호로 인해 확인 버튼을 누르시면 답변이 삭제됩니다",
    "To safeguard your valuable privacy, pressing the confirm button will delete your response.",
    "为了保护您宝贵的隐私，确认按钮将删除回答",
    "貴重な個人情報の保護のため、確認ボタンを押すと回答が削除されます",
    "การกดปุ่มยืนยันจะลบการตอบกลับเพื่อป้องกันความเป็นส่วนตัวที่มีค่าของคุณ",
    "Para proteger su valiosa privacidad, al presionar el botón de confirmación se eliminará su respuesta.",
    "Pour protéger votre précieuse vie privée, en appuyant sur le bouton de confirmation, votre réponse sera supprimée.",
    "Для защиты вашей ценной конфиденциальности нажатие кнопки подтверждения приведет к удалению вашего ответа.",
    "Zum Schutz Ihrer wertvollen Privatsphäre wird durch Drücken der Bestätigungs-Schaltfläche Ihre Antwort gelöscht.",
  ],
  // cartInto
  cartInto_button_order: [
    "주문하기",
    "Order",
    "下单",
    "注文する",
    "สั่งซื้อ",
    "Hacer pedido",
    "Commander",
    "Заказ",
    "Bestellen",
  ],
  cartInto_button_reset: [
    "비우기",
    "Reset",
    "重置",
    "リセット",
    "รีเซ็ต",
    "Vaciar",
    "Réinitialiser",
    "Сбросить",
    "Zurücksetzen",
  ],

  // optionModal
  optionModal_title_optionSelect: [
    "옵션 선택",
    "Option Select",
    "选择选项",
    "オプションを選択",
    "เลือกตัวเลือก",
    "Seleccionar opción",
    "Choisir une option",
    "Выбрать опцию",
    "Option auswählen",
  ],
  optionModal_button_ClearAll: [
    "취소",
    "Cancel",
    "取消",
    "キャンセル",
    "ยกเลิก",
    "Cancelar",
    "Annuler",
    "Отмена",
    "Stornieren",
  ],
  optionModal_button_AddToCart: [
    "장바구니 담기",
    "Add to Cart",
    "加入购物车",
    "カートに追加",
    "เพิ่มในตะกร้า",
    "Agregar al carrito",
    "Ajouter au panier",
    "Добавить в корзину",
    "In den Warenkorb",
  ],
  optionModal_title_Required: [
    "필수",
    "Required",
    "必须",
    "必須",
    "จำเป็น",
    "Obligatorio",
    "Obligatoire",
    "Обязательный",
    "Pflicht",
  ],
  optionModal_title_Maximum: [
    "최대",
    "Maximum",
    "最大",
    "最大",
    "สูงสุด",
    "Máximo",
    "Maximum",
    "Максимум",
    "Maximal",
  ],
  optionModal_detail_choice: [
    "개 선택해주세요",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],

  // storeDetails
  storeDetails_slideWrap: [
    "입니다. 서둘러 주문해주세요",
    "Please order quickly",
    "请快速下单",
    "急いで注文してください",
    "โปรดสั่งด่วน",
    "¡Por favor, haga su pedido rápidamente!",
    "Merci de commander rapidement",
    "Пожалуйста, заказывайте быстро",
    "Bitte schnell bestellen",
  ],
  storeDetails_button_cart: [
    "장바구니 보기",
    "Go to Pay",
    "去支付",
    "支払いに行く",
    "ไปชำระเงิน",
    "Ir a pagar",
    "Aller payer",
    "Перейти к оплате",
    "Zur Kasse gehen",
  ],

  // menuInfo
  menuInfo_store_info: [
    "매장 정보",
    "Store info",
    "商店信息",
    "店舗情報",
    "ข้อมูลร้าน",
    "Información de la tienda",
    "Infos sur le magasin",
    "Инфо о магазине",
    "Geschäftsinfo",
  ],
  menuInfo_delivery_info: [
    "배달 정보",
    "Delivery info",
    "配送信息",
    "配達情報",
    "ข้อมูลการจัดส่ง",
    "Información de entrega",
    "Infos de livraison",
    "Инфо о доставке",
    "Lieferinfo",
  ],
  menuInfo_title_optionRequired: [
    "필수 옵션을 선택해 주세요",
    "Please select the required options",
    "请选择必选选项",
    "必須オプションを選択してください",
    "กรุณาเลือกตัวเลือกที่จำเป็น",
    "Seleccione las opciones requeridas",
    "Veuillez sélectionner les options requises",
    "Пожалуйста, выберите обязательные параметры",
    "Bitte wählen Sie die erforderlichen Optionen",
  ],
  menuInfo_category_storeInfo: [
    "매장안내",
    "Information",
    "信息",
    "情報",
    "ข้อมูล",
    "Información",
    "Informations",
    "Информация",
    "Informationen",
  ],
  menuInfo_business_time: [
    "영업시간",
    "Business hours",
    "营业时间",
    "営業時間",
    "เวลาทำการ",
    "Horas de operación",
    "Heures d'ouverture",
    "Часы работы",
    "Öffnungszeiten",
  ],
  menuInfo_store_tel: [
    "매장번호",
    "Store contact",
    "商店联系方式",
    "店舗の連絡先",
    "ติดต่อร้าน",
    "Número de la tienda",
    "Contact du magasin",
    "Контакт магазина",
    "Kontakt zum Geschäft",
  ],
  menuInfo_address: [
    "주소",
    "Address",
    "地址",
    "住所",
    "ที่อยู่",
    "Dirección",
    "Adresse",
    "Адрес",
    "Adresse",
  ],
  menuInfo_delivery_time: [
    "배달 예상시간",
    "Delivery time",
    "送货时间",
    "配達時間",
    "เวลาส่ง",
    "Tiempo de entrega",
    "Temps de livraison",
    "Время доставки",
    "Lieferzeit",
  ],
  delivery_time_notice: [
    "배달시간",
    "Delivery time",
    "送货时间",
    "配達時間",
    "เวลาส่ง",
    "Tiempo de entrega",
    "Temps de livraison",
    "Время доставки",
    "Lieferzeit",
  ],
  delivery_price_free: [
    "무료",
    "free",
    "自由的",
    "無料",
    "ฟรี",
    "Gratis",
    "Gratuit",
    "Бесплатно",
    "Kostenlos",
  ],

  menuInfo_event: [
    "이벤트",
    "Event",
    "活动",
    "イベント",
    "กิจกรรม",
    "Evento",
    "Événement",
    "Событие",
    "Veranstaltung",
  ],
  menuInfo_notification: [
    "공지사항",
    "Notice",
    "通知",
    "お知らせ",
    "ประกาศ",
    "Aviso",
    "Avis",
    "Уведомление",
    "Hinweis",
  ],
  menuInfo_delivery_fee: [
    "배달비",
    "Delivery fee",
    "配送费用",
    "配達料金",
    "ค่าจัดส่ง",
    "Cargo de entrega",
    "Frais de livraison",
    "Доставка",
    "Liefergebühr",
  ],
  menuInfo_base_delivery_price: [
    "최소주문금액",
    "Minimum order amount",
    "最低订单金额",
    "最低注文金額",
    "ยอดสั่งขั้นต่ำ",
    "Monto mínimo de pedido",
    "Montant minimum de commande",
    "Минимальная сумма заказа",
    "Mindestbestellwert",
  ],
  more_price: [
    "이상",
    "or more",
    "元以上",
    "ォン以上",
    "ล้านวอน",
    "o más",
    "ou plus",
    "или больше",
    "oder mehr",
  ],
  menuInfo_none: [
    "없습니다",
    "Not available",
    "没有",
    "ありません",
    "ไม่มี",
    "No disponible",
    "Non disponible",
    "Нет в наличии",
    "Nicht verfügbar",
  ],
  menuInfo_origin_info: [
    "원산지정보",
    "Origin info",
    "原产地信息",
    "原産地情報",
    "ข้อมูลต้นทาง",
    "Información de origen",
    "Informations sur l'origine",
    "Информация о происхождении",
    "Herkunftsinfo",
  ],
  menuInfo_upper: [
    " 이상입니다",
    "Minimum order amount is ",
    "最低订单金额为",
    "以上のご注文が必要です",
    "ยอดสั่งขั้นต่ำ ",
    "El importe mínimo de pedido es ",
    "Le montant minimum de commande est ",
    "Минимальная сумма заказа ",
    "Der Mindestbestellbetrag beträgt ",
  ],
  menuInfo_other_store: [
    "같은 매장의 메뉴만 담을 수 있어요.\n장비구니에 담긴 메뉴를 모두 삭제하고\n새로운 메뉴를 담으시겠어요?",
    "Only items from the same store can be added.\nWould you like to delete all previously added items\nand add the new ones?",
    "只能包含同一家店的菜单。\n我们删除所有先前的菜单，\n然后添加新的菜单吗？",
    "同じ店のメニューのみを含めることが\nできます。\n以前のメニューをすべて削除して、\n新しいメニューを追加しますか？",
    "สามารถเพิ่มเมนูจากร้านเดียวกันเท่านั้น\nเราควรลบเมนูทั้งหมดที่ผ่านมาแล้วและ\nเพิ่มเมนูใหม่หรือไม่?",
    "Solo se pueden agregar artículos de la misma tienda.\n¿Desea eliminar todos los artículos previamente agregados\ny agregar los nuevos?",
    "Vous ne pouvez ajouter que des articles du même magasin.\nVoulez-vous supprimer tous les articles précédemment ajoutés\net ajouter les nouveaux ?",
    "Можно добавлять только товары из одного и того же магазина.\nХотите удалить все ранее добавленные товары\nи добавить новые?",
    "Nur Artikel aus demselben Geschäft können hinzugefügt werden.\nMöchten Sie alle zuvor hinzugefügten Artikel löschen\nund die neuen hinzufügen?",
  ],
  menuInfo_toast_select_source: [
    "번 구성을 선택해주세요",
    "Please select a configuration ",
    "请选择配置",
    "番の構成を選択してください",
    "โปรดเลือกการกำหนดค่า ",
    "Por favor, seleccione la configuración ",
    "Veuillez sélectionner la configuration ",
    "Пожалуйста, выберите конфигурацию ",
    "Bitte wählen Sie die Konfiguration ",
  ],
  menuInfo_toast_set_option_1: [
    "구성 ",
    "Please select ",
    "请选择",
    "構成",
    "ปรดเลือกตัวเลือก ",
    "Por favor, seleccione ",
    "Veuillez sélectionner ",
    "Пожалуйста, выберите ",
    "Bitte wählen Sie ",
  ],
  menuInfo_toast_set_option_2: [
    "의 상품 ",
    " options for ",
    "配置中产品",
    "の商品",
    " สำหรับตัวเลือก ",
    " opción de las ",
    " option parmi les ",
    " вариант из ",
    " Option aus den ",
  ],
  menuInfo_toast_set_option_3: [
    "의 ",
    " options of product ",
    "的",
    "の",
    " ของสินค้า ",
    " opciones del producto ",
    " options du produit ",
    " вариантов продукта ",
    " Optionen des Produkts ",
  ],
  menuInfo_toast_set_option_4: [
    "옵션을 ",
    " of configuration ",
    "个选项的",
    "オプションを'",
    " ในการกำหนดค่า ",
    " en la configuración",
    " dans la configuration",
    " в конфигурации",
    " in der Konfiguration",
  ],
  menuInfo_toast_set_option_5: [
    "개 선택해주세요",
    "",
    "个选项",
    "個選択してください'",
    "",
    "",
    "",
    "",
    "",
  ],
  menuInfo_toast_setOption_option_1: [
    "추가상품의 ",
    "Please select ",
    "请为附加产品的",
    "追加商品の",
    "โปรดเลือกตัวเลือก ",
    "Por favor, seleccione ",
    "Veuillez sélectionner ",
    "Пожалуйста, выберите ",
    "Bitte wählen Sie ",
  ],
  menuInfo_toast_setOption_option_2: [
    "옵션을 ",
    " options for ",
    "选项选择",
    "オプションを",
    " สำหรับตัวเลือก ",
    " opción de las opciones ",
    " option parmi les options ",
    " вариант из опций ",
    " Option aus den ",
  ],
  menuInfo_toast_setOption_option_3: [
    "개 선택해주세요",
    "options of additional product",
    "个选项",
    "個選択してください",
    " ของสินค้าเพิ่มเติม",
    " del producto adicional",
    " du produit supplémentaire",
    " дополнительного продукта",
    "-Optionen des zusätzlichen Produkts",
  ],
  menuInfo_toast_added: [
    "담기",
    "Added to cart",
    "已添加到购物车",
    "カートに追加",
    "เพิ่มในตะกร้า",
    "Agregado al carrito",
    "Ajouté au panier",
    "Добавлено в корзину",
    "In den Warenkorb gelegt",
  ],

  // paymentListModal
  paymentListModal_title_name: [
    "결제내역",
    "Payment history",
    "支付记录",
    "支払い履歴",
    "ประวัติการชำระเงิน",
    "Historial de pagos",
    "Historique des paiements",
    "История платежей",
    "Zahlungshistorie",
  ],
  paymentListModal_title_productPrice: [
    "상품금액",
    "Product price",
    "商品金额",
    "商品価格",
    "ราคาสินค้า",
    "Precio del producto",
    "Prix du produit",
    "Цена товара",
    "Produktpreis",
  ],
  paymentListModal_title_orderAmount: [
    "주문금액",
    "Order amount",
    "订单金额",
    "注文金額",
    "ยอดคำสั่งซื้อ",
    "Monto del pedido",
    "Montant de la commande",
    "Сумма заказа",
    "Bestellbetrag",
  ],
  paymentListModal_title_totalPayment: [
    "총 결제 금액",
    "Total payment",
    "总付款金额",
    "総支払金額",
    "ยอดชำระทั้งหมด",
    "Pago total",
    "Montant total",
    "Общая сумма платежа",
    "Gesamtzahlung",
  ],
  payment_completed: [
    "결제가 완료되었어요",
    "Your payment has been completed.",
    "付款已完成。",
    "決済が完了しました。",
    "ชำระเงินเรียบร้อยแล้วค่ะ",
    "Tu pago ha sido completado.",
    "Votre paiement a été complété.",
    "Ваш платеж завершен.",
    "Ihre Zahlung wurde abgeschlossen.",
  ],
  paymentListModal_title_request: [
    "주문 시 요청사항",
    "Requests",
    "特殊要求",
    "特別なリクエスト",
    "คำขอพิเศษ",
    "Solicitudes",
    "Demandes",
    "Запросы",
    "Anfragen",
  ],
  paymentListModal_title_delivery_cost: [
    "배달팁",
    "Delivery fee",
    "配送费用",
    "配達料金",
    "ค่าจัดส่ง",
    "Cargo de entrega",
    "Frais de livraison",
    "Доставка",
    "Liefergebühr",
  ],
  paymentListModal_title_pickup_location: [
    "배달 장소",
    "Delivery point",
    "交货点",
    "配達ポイント",
    "จุดจัดส่ง",
    "Punto de entrega",
    "Point de livraison",
    "Точка доставки",
    "Lieferpunkt",
  ],
  paymentListModal_title_thblecloth: [
    "식탁보",
    "Tablecloth",
    "餐桌布",
    "テーブルクロス",
    "ผ้าโต๊ะ",
    "Mantel",
    "Nappe",
    "Скатерть",
    "Tischdecke",
  ],
  paymentListModal_title_clean_bag: [
    "정리봉투",
    "Cleanup bag",
    "整理袋",
    "整理バッグ",
    "ถุงทำความสะอาด",
    "Bolsa de limpieza",
    "Sac de nettoyage",
    "Мешок для уборки",
    "Reinigungstasche",
  ],
  paymentListModal_title_discount: [
    "할인금액",
    "Discounted amount",
    "折扣后金额",
    "割引後の金額",
    "จำนวนเงินที่ลดลง",
    "Monto descontado",
    "Montant remisé",
    "Сумма скидки",
    "Rabattbetrag",
  ],
  paymentListModal_maximum_discount: [
    "최대 할인으로 자동 적용되었습니다",
    "Maximum discount",
    "最大折扣应用",
    "最大の割引が適用されました",
    "การใช้ส่วนลดสูงสุด",
    "Descuento máximo",
    "Remise maximale",
    "Максимальная скидка",
    "Maximale Ersparnis",
  ],
  paymentListModal_title_coupon: [
    "쿠폰등록",
    "Add coupon",
    "注册优惠券",
    "クーポンを登録",
    "ลงทะเบียนคูปอง",
    "Agregar cupón",
    "Ajouter un coupon",
    "Добавить купон",
    "Gutschein hinzufügen",
  ],
  paymentListModal_coupon_code: [
    "쿠폰코드입력",
    "Coupon code",
    "优惠券代码",
    "クーポンコード",
    "รหัสคูปอง",
    "Código de cupón",
    "Code promo",
    "Код купона",
    "Gutscheincode",
  ],
  paymentListModal_title_product_discount: [
    "상품할인",
    "Product",
    "商品折扣",
    "商品割引",
    "สินค้า",
    "Producto",
    "Produit",
    "Продукт",
    "Produkt",
  ],
  paymentListModal_title_coupon_discount: [
    "쿠폰할인",
    "Coupon",
    "优惠券折扣",
    "クーポン割引",
    "คูปอง",
    "Cupón",
    "Coupon",
    "Купон",
    "Gutschein",
  ],
  paymentListModal_placeholder: [
    "사장님께 요청사항을 입력해주세요 (선택)",
    "Please write your requests (optional)",
    "请写下您的请求（可选项）",
    "リクエストを書いてください（任意）",
    "กรุณาเขียนคำขอของคุณ (ไม่บังคับ)",
    "Por favor, escriba sus solicitudes (opcional)",
    "Veuillez écrire vos demandes (facultatif)",
    "Пожалуйста, напишите ваши запросы (по желанию)",
    "Bitte schreiben Sie Ihre Anfragen (optional)",
  ],
  paymentListModal_button_payment: [
    "결제하기",
    "Purchase",
    "购买",
    "購入",
    "การซื้อ",
    "Compra",
    "Achat",
    "Покупка",
    "Kauf",
  ],
  paymentListModal_button_order_limit: [
    "부터 주문할 수 있어요",
    "You can order from ",
    "最低订单金额为",
    "から注文できます",
    "คุณสามารถสั่งซื้อได้ตั้งแต่",
    "Puedes ordenar desde ",
    "Vous pouvez commander depuis ",
    "Вы можете заказать из ",
    "Sie können von hier bestellen ",
  ],
  paymentListModal_toast_exceed: [
    "입력은 80자를 초과할 수 없습니다.",
    "Input cannot exceed 80 characters.",
    "输入不能超过80个字符。",
    "入力は80文字を超えることはできません。",
    "การป้อนต้องไม่เกิน 80 ตัวอักษร",
    "La entrada no puede exceder los 80 caracteres.",
    "L'entrée ne peut pas dépasser 80 caractères.",
    "Ввод не может превышать 80 символов.",
    "Die Eingabe darf 80 Zeichen nicht überschreiten.",
  ],
  paymentListModal_toast_add_coupon: [
    "쿠폰을 추가했어요",
    "Coupon added",
    "添加了一张优惠券",
    "クーポンを追加しました",
    "เพิ่มคูปองแล้ว",
    "Cupón agregado",
    "Coupon ajouté",
    "Купон добавлен",
    "Gutschein hinzugefügt",
  ],
  paymentListModal_toast_coupon_code_error: [
    "조회된 쿠폰이 없어요",
    "No coupons found",
    "找不到优惠券",
    "クーポンが見つかりません",
    "ไม่พบคูปอง",
    "No se encontraron cupones",
    "Aucun coupon trouvé",
    "Купонов не найдено",
    "Es wurden keine Gutscheine gefunden",
  ],
  paymentListModal_toast_already_coupon: [
    "이미 다른 쿠폰을 추가했어요",
    "Another coupon is already added",
    "已经添加了其他优惠券",
    "既に他のクーポンを追加済みです",
    "คูปองอื่นถูกเพิ่มแล้ว",
    "Otro cupón ya ha sido agregado",
    "Un autre coupon a déjà été ajouté",
    "Другой купон уже добавлен",
    "Ein anderer Gutschein wurde bereits hinzugefügt",
  ],
  paymentListModal_unavailable_notice: [
    "원 이상 주문 시 사용가능",
    "KRW Available for orders over",
    "韩元以上时可使用",
    "ウォン以上のご注文時に使用可能",
    "วอน สามารถใช้ได้เมื่อสั่งซื้อมากกว่า",
    "KRW disponible para pedidos superiores a",
    "KRW disponible pour les commandes supérieures à",
    "KRW доступен для заказов свыше",
    "KRW ist verfügbar für Bestellungen über",
  ],

  paymentListModal_button_pay_normal: [
    "일반결제",
    "Pay normal",
    "普通支付",
    "通常の支払い",
    "การชำระเงินปกติ",
    "Pago normal",
    "Paiement normal",
    "Обычная оплата",
    "Normale Zahlung",
  ],
  paymentListModal_button_pay_easy: [
    "자주 이용한다면, 간편결제 등록",
    "Register for easy payment",
    "便捷支付注册",
    "簡単決済を登録する",
    "ลงทะเบียนชำระเงินง่าย",
    "Registrar para pago fácil",
    "Inscrivez-vous pour un paiement facile",
    "Зарегистрируйтесь для лёгкой оплаты",
    "Für einfache Zahlung registrieren",
  ],
  paymentListModal_comment_easy: [
    "간편결제 등록하고 포인트 적립하세요",
    "Register for easy payment and earn points",
    "注册便捷支付并赚取积分",
    "簡単な支払いを登録してポイントを獲得してください",
    "ลงทะเบียนชำระเงินง่ายและได้รับคะแนน",
    "Registre el pago fácil y gane puntos",
    "Inscrivez-vous pour un paiement facile et gagnez des points",
    "Зарегистрируйтесь для лёгкой оплаты и зарабатывайте баллы",
    "Registrieren Sie sich für einfache Zahlung und sammeln Sie Punkte",
  ],

  // setOptionModal
  setOptionModal_title: [
    "세트메뉴 선택",
    "Select a set menu",
    "选择套餐",
    "セットメニュー選択",
    "เลือกเมนูเซ็ต",
    "Seleccione un menú de conjunto",
    "Sélectionnez un menu fixe",
    "Выберите набор меню",
    "Wählen Sie ein Set-Menü aus",
  ],
  setOptionModal_select_menu: [
    "메뉴를 선택해주세요",
    "Please select a menu",
    "请选择菜单",
    "メニューを選択してください",
    "กรุณาเลือกเมนู",
    "Por favor seleccione un menú",
    "Veuillez sélectionner un menu",
    "Пожалуйста, выберите меню",
    "Bitte wählen Sie ein Menü",
  ],
  setOptionModal_configuration: [
    "구성",
    "Configuration",
    "配置",
    "構成",
    "การกำหนดค่า",
    "Configuración",
    "Configuration",
    "Конфигурация",
    "Konfiguration",
  ],
  setOptionModal_addtional: [
    "추가",
    "Additional",
    "额外的",
    "追加",
    "เพิ่มเติม",
    "Adicional",
    "Supplémentaire",
    "Дополнительный",
    "Zusätzlich",
  ],
  setOptionModal_option: [
    "옵션",
    "Option",
    "选项",
    "オプション",
    "ตัวเลือก",
    "Opción",
    "Option",
    "Опция",
    "Option",
  ],
  setOptionModal_select_option: [
    "옵션 선택하기",
    "Select options",
    "选择选项",
    "オプションを選択する",
    "การเลือกตัวเลือก",
    "Seleccionar opciones",
    "Sélectionner les options",
    "Выбор опций",
    "Option auswählen",
  ],
  setOptionModal_maximum_count: [
    "개 선택 가능",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],

  // guideModal
  guideModal_title: [
    "노크노크는,",
    "KNOCKKNOCK is,",
    "敲敲是,",
    "ノックノックは,",
    "เค้าโครงคือ,",
    "KNOCKKNOCK es",
    "KNOCKKNOCK est",
    "KNOCKKNOCK это",
    "KNOCKKNOCK ist",
  ],
  guideModal_title_one: [
    "배달 평점 4.9점 이상만!",
    "Only 4.9+ Delivery Ratings!",
    "仅限评分4.9以上的配送",
    "配達評価4.9以上のみ!",
    "เฉพาะคะแนนการจัดส่ง 4.9 ขึ้นไป!",
    "¡Solo calificaciones de entrega de 4.9 o más!",
    "Notes de livraison de 4.9 et plus uniquement !",
    "Только с рейтингом доставки 4.9 и выше!",
    "Nur Lieferbewertungen ab 4,9!",
  ],
  guideModal_content_one: [
    "- 배달 앱 검색하실 필요 없어요!",
    "- No need to search delivery apps!",
    "- 无需搜索配送应用程序!",
    "- 配達アプリを検索する必要はありません！",
    "- ไม่ต้องค้นหาแอปส่งอาหาร!",
    "- ¡No necesita buscar aplicaciones de entrega!",
    "- Pas besoin de chercher d'application de livraison!",
    "- Нет необходимости искать приложения для доставки!",
    "- Keine Notwendigkeit, Liefer-Apps zu durchsuchen!",
  ],
  guideModal_title_two: [
    "초간편 주문!",
    "Super Easy Order!",
    "超简便订购!",
    "超簡単注文！",
    "สั่งง่ายสุดๆ!",
    "¡Pedido súper fácil!",
    "Commande ultra-facile !",
    "Супер простой заказ!",
    "Super einfache Bestellung!",
  ],
  guideModal_content_two: [
    "- 객실 자동설정.앱 설치 NO! 회원가입 NO!",
    "- Room auto-setup. No app installation! No sign-up!",
    "- 客房自动设置。无需安装应用！无需注册！",
    "- 客室の自動設定。アプリのインストール不要！登録不要！",
    "- ตั้งค่าห้องอัตโนมัติ ไม่ต้องติดตั้งแอป! ไม่ต้องสมัครสมาชิก!",
    "- Configuración automática de habitación. ¡Sin instalación de app! ¡Sin registro!",
    "- Configuration automatique de la chambre. Pas d'installation d'application ! Pas d'inscription !",
    "- Автоматическая настройка номера. Без установки приложений! Без регистрации!",
    "- Automatische Zimmerkonfiguration. Keine App-Installation! Keine Anmeldung!",
  ],
  guideModal_title_three: [
    "100% 안심 정책",
    "100% safe policy",
    "100% 满意保证",
    "100% 満足保証",
    "100% เช็คเอ้าท์",
    "Política 100% segura",
    "Politique 100% sûre",
    "100% безопасная политика",
    "100% sichere Richtlinie",
  ],
  guideModal_content_three: [
    "- 서비스 문의, 불편 신고는 노크노크로!",
    "- For inquiries or complaints, please contact KNOCKKNOCK!",
    "- 有问题或投诉，请联系 KNOCKKNOCK！",
    "- 問い合わせや苦情は、ノックノックに連絡してください！",
    "- ถามคำถามหรือรายงานปัญหาได้ที่ KNOCKKNOCK!",
    "- Para consultas o quejas, comuníquese con KNOCKKNOCK.",
    "- Pour toute demande ou réclamation, veuillez contacter KNOCKKNOCK.",
    "- Для запросов или жалоб, пожалуйста, свяжитесь с KNOCKKNOCK.",
    "- Für Anfragen oder Beschwerden wenden Sie sich bitte an KNOCKKNOCK.",
  ],
  guideModal_footer: [
    "※ 호텔은 고객님의 배달주문을 전혀 알 수 없어요.\n요청 사항은 주문하신 음식점이나 카카오톡 노크노크 고객센터로 연락 부탁드립니다.",
    "※ The hotel is not aware of your order. Please reach out to the restaurant you ordered from or contact 'KNOCKKNOCK Customer Center' on KakaoTalk for assistance.",
    "※ 酒店不知道您的外卖订单。有任何要求，\n请联系您订购的餐厅或KakaoTalk KNOCKKNOCK客户服务中心。",
    "※ ホテルはお客様のデリバリー注文について全く知りません。お問い合わせは、\nご注文いただいたレストランまたはカカオトークノックノックカスタマーセンターまでお願いします。",
    "※ โรงแรมไม่ทราบข้อมูลการส่งสินค้าของคุณเลยค่ะ\nกรุณาติดต่อร้านอาหารที่คุณสั่งหรือติดต่อศูนย์บริการลูกค้า KakaoTalk KNOCKKNOCK ค่ะ",
    "※ El hotel no puede rastrear los pedidos de entrega.\nPar consultas, contacte al restaurante o al servicio al cliente de KakaoTalk KnockKnock.",
    "※ L'hôtel ne peut pas suivre les commandes de livraison.\nPour toute demande, contactez le restaurant ou le service client KakaoTalk KnockKnock.",
    "※ Отель не может отслеживать заказы доставки.\nДля запросов свяжитесь с рестораном или службой поддержки KakaoTalk KnockKnock.",
    "※ Das Hotel kann Lieferbestellungen nicht verfolgen.\nBei Anfragen wenden Sie sich an das Restaurant oder den KakaoTalk KnockKnock-Kundendienst.",
  ],
  guideModal_button_confirm: [
    "확인했어요",
    "Confirm",
    "确认",
    "確認",
    "การยืนยัน",
    "Confirmar",
    "Confirmer",
    "Подтвердить",
    "Bestätigen",
  ],
  guideModal_button_pickup: [
    "배달 위치는 ",
    "Pickup location is ",
    "取件位置是",
    "ピックアップ場所は",
    "ตำแหน่งการรับสินค้าคือ ",
    "La ubicación de la entrega está ",
    "Le lieu de livraison est ",
    "Местоположение доставки ",
    "Der Lieferort ist ",
  ],
  guideModal_room_tip: [
    "객실관리팁 안내",
    "Room tips guide",
    "客房管理小贴士",
    "客室管理のコツのご案内",
    "แนะนำเคล็ดลับการดูแลห้องพัก",
    "Guía de propinas para la habitación",
    "Guide de pourboire de la chambre",
    "Руководство по чаевым в номере",
    "Trinkgeld-Leitfaden für Zimmer",
  ],
  guideModal_room_tip_notice: [
    "청결한 객실 관리를 위해서 외부배달앱 사용이 불가능하며, \n객실관리팁이 부과됩니다.",
    "For clean room management, external delivery apps are not available, \nand room tips will be charged.",
    "为了干净的客房管理,不能使用外部配送应用程序,\n会收取客房管理费。",
    "清潔な客室管理のため、外部からのデリバリーアプリの使用は不可能であり、\n客室管理のコツがあります。",
    "สำหรับการจัดการห้องพักที่สะอาดไม่สามารถใช้แอปการจัดส่งภายนอกได้และจะมีทิปการจัดการห้องพักค่ะ",
    "Para mantener la limpieza, no se permiten aplicaciones externas\ny se cobrará un servicio.",
    "Pour la propreté de la chambre, les apps externes sont interdites,\nun pourboire est facturé.",
    "Для чистоты номера запрещены сторонние приложения,\nбудет взиматься чаевые.",
    "Zur Sauberkeit der Zimmer sind externe Apps verboten,\nund es wird eine Gebühr erhoben.",
  ],
  guideModal_alarm_guide: [
    "알림설정을 꼭 켜주세요!\n배달이 완료되면 알려드릴게요",
    "Please turn on notification settings!\nWe will notify you when the delivery is complete",
    "请打开通知设置!配送完成后我们会通知您",
    "通知設定をオンにしてください!\n配達が完了したらお知らせします",
    "โปรดเปิดการตั้งค่าการแจ้งเตือน!\nจะแจ้งให้คุณทราบเมื่อการจัดส่งเสร็จสิ้น",
    "¡Por favor, active la configuración de notificaciones!\nLe notificaremos cuando la entrega esté completa",
    "Veuillez activer les paramètres de notification!\nNous vous informerons lorsque la livraison sera terminée",
    "Пожалуйста, включите настройки уведомлений!\nМы уведомим вас, когда доставка будет завершена",
    "Bitte schalten Sie die Benachrichtigungseinstellungen ein!\nWir benachrichtigen Sie, wenn die Lieferung abgeschlossen ist",
  ],
  password_reset_password: [
    "비밀번호 재설정",
    "Reset Password",
    "重设密码",
    "パスワードをリセットする",
    "รีเซ็ตรหัสผ่าน",
    "Restablecer la contraseña",
    "Réinitialiser le mot de passe",
    "Сбросить пароль",
    "Passwort zurücksetzen",
  ],
  password_button_delete_all: [
    "전체삭제",
    "Delete All",
    "全部删除",
    "すべて削除",
    "ลบทั้งหมด",
    "Eliminar todo",
    "Tout supprimer",
    "Удалить всё",
    "Alles löschen",
  ],
  password_title_reset_check: [
    "재설정 비밀번호 확인",
    "Check Reset Password",
    "检查重置密码",
    "リセットパスワードの確認",
    "ตรวจสอบรหัสผ่านรีเซ็ต",
    "Verificar contraseña restablecida",
    "Vérifier le mot de passe réinitialisé",
    "Проверить сброшенный пароль",
    "Zurückgesetztes Passwort überprüfen",
  ],
  password_title_password: [
    "비밀번호 입력",
    "Enter Password",
    "输入密码",
    "パスワードを入力",
    "ป้อนรหัสผ่าน",
    "Introducir contraseña",
    "Entrez le mot de passe",
    "Введите пароль",
    "Passwort eingeben",
  ],
  password_title_reset_password: [
    "재설정 비밀번호 입력하기",
    "Enter Reset Password",
    "输入重置密码",
    "リセットパスワードを入力",
    "ป้อนรหัสผ่านรีเซ็ต",
    "Introducir contraseña de restablecimiento",
    "Entrez le mot de passe de réinitialisation",
    "Введите пароль для сброса",
    "Zurücksetzpasswort eingeben",
  ],
  authenticationModal_title: [
    "전화번호 인증",
    "Verify Phone",
    "手机验证",
    "携帯電話認証",
    "ยืนยันโทรศัพท์มือถือ",
    "Verificar teléfono",
    "Vérifier le téléphone",
    "Проверить телефон",
    "Telefon überprüfen",
  ],
  authenticationModal_phone_number: [
    "전화번호",
    "Phone Number",
    "电话号码",
    "電話番号",
    "หมายเลขโทรศัพท์",
    "Número de teléfono",
    "Numéro de téléphone",
    "Номер телефона",
    "Telefonnummer",
  ],
  authenticationModal_verity_code: [
    "인증번호",
    "Verification Code",
    "验证码",
    "認証コード",
    "รหัสยืนยัน",
    "Código de verificación",
    "Code de vérification",
    "Код подтверждения",
    "Bestätigungscode",
  ],
  authenticationModal_button_receieve: [
    "인증번호 받기",
    "Receive Code",
    "接收验证码",
    "認証コードを受け取る",
    "รับรหัสยืนยัน",
    "Recibir código",
    "Recevoir le code",
    "Получить код",
    "Code erhalten",
  ],
  authenticationModal_placeholder_phone_number: [
    "-없이 번호만 입력해주세요",
    "Please enter the numbers without -",
    "请输入不带 - 的数字",
    "-を抜いた数字のみを入力してください",
    "โปรดป้อนเฉพาะตัวเลขโดยไม่ต้องใส่ -",
    "Por favor, ingrese solo los números sin -",
    "Veuillez entrer uniquement les chiffres sans -",
    "Пожалуйста, вводите только цифры без -",
    "Bitte geben Sie nur die Zahlen ohne - ein",
  ],
  authenticationModal_placeholder_code: [
    "인증번호를 입력해주세요",
    "Please enter the verification code",
    "请输入验证码",
    "認証コードを入力してください",
    "โปรดป้อนรหัสยืนยัน",
    "Por favor, ingrese el código de verificación",
    "Veuillez entrer le code de vérification",
    "Пожалуйста, введите код подтверждения",
    "Bitte geben Sie den Bestätigungscode ein",
  ],
  authenticationModal_button_complete: [
    "인증완료",
    "Complete",
    "完成认证",
    "認証完了",
    "เสร็จสิ้น",
    "Completar",
    "Compléter",
    "Завершить",
    "Abschließen",
  ],
  cardListModal_title: [
    "카드선택",
    "Select Card",
    "选择卡",
    "カードを選択",
    "เลือกบัตร",
    "Seleccionar tarjeta",
    "Sélectionner une carte",
    "Выбрать карту",
    "Karte auswählen",
  ],
  cardListModal_button_add: [
    "카드 추가하기",
    "Add Card",
    "添加卡",
    "カードを追加する",
    "เพิ่มบัตร",
    "Agregar tarjeta",
    "Ajouter une carte",
    "Добавить карту",
    "Karte hinzufügen",
  ],
  cardListModal_button_complete: [
    "선택 완료하기",
    "Complete",
    "选择完成",
    "選択完了",
    "เสร็จสิ้น",
    "Completar",
    "Compléter",
    "Завершить",
    "Abschließen",
  ],
  cardListModal_comment_none: [
    "카드를 등록해놓으면\n매번 쉽게 결제할 수 있어요",
    "Once you register your card,\nyou can easily make payments every time",
    "注册卡后，\n您每次都可以轻松付款",
    "カードを登録しておくと、\n毎回簡単に支払いができます",
    "หลังจากลงทะเบียนบัตรแล้ว \nคุณสามารถชำระเงินได้อย่างสะดวกทุกครั้ง",
    "Una vez que registre su tarjeta,\npodrá realizar pagos fácilmente cada vez",
    "Une fois que vous avez enregistré votre carte,\nvous pouvez facilement effectuer des paiements à chaque fois",
    "После регистрации карты\nвы можете легко производить оплату каждый раз",
    "Sobald Sie Ihre Karte registriert haben,\nkönnen Sie bei jedem Mal einfach bezahlen",
  ],
  addCardModal_title: [
    "간편결제 등록",
    "Register Card",
    "注册便捷支付",
    "簡単な支払いを登録する",
    "ลงทะเบียนชำระเงินง่าย",
    "Registrar tarjeta",
    "Enregistrer la carte",
    "Зарегистрировать карту",
    "Karte registrieren",
  ],
  addCardModal_card_number: [
    "카드번호",
    "Card Number",
    "卡号",
    "カード番号",
    "หมายเลขบัตร",
    "Número de tarjeta",
    "Numéro de carte",
    "Номер карты",
    "Kartennummer",
  ],
  addCardModal_expired_date: [
    "유효기간",
    "Expired Date",
    "有效期",
    "有効期限",
    "วันที่หมดอายุ",
    "Fecha de caducidad",
    "Date d'expiration",
    "Срок действия",
    "Ablaufdatum",
  ],
  addCardModal_birth_date: [
    "생년월일",
    "Birth Date",
    "出生日期",
    "生年月日",
    "วันเกิด",
    "Fecha de nacimiento",
    "Date de naissance",
    "Дата рождения",
    "Geburtsdatum",
  ],
  addCardModal_password: [
    "비밀번호",
    "Password",
    "密码",
    "パスワード",
    "รหัสผ่าน",
    "Contraseña",
    "Mot de passe",
    "Пароль",
    "Passwort",
  ],
  addCardModal_placeholder_card_number: [
    "숫자만 입력해주세요",
    "Please enter only numbers",
    "请只输入数字",
    "数字のみを入力してください",
    "โปรดป้อนตัวเลขเท่านั้น",
    "Por favor, ingrese solo números",
    "Veuillez entrer uniquement des chiffres",
    "Пожалуйста, вводите только цифры",
    "Bitte geben Sie nur Zahlen ein",
  ],
  addCardModal_placeholder_password: [
    "앞 2자리",
    "First 2 digits",
    "前2位",
    "最初の2桁",
    "2 หลักแรก",
    "Primeras 2 cifras",
    "Premiers 2 chiffres",
    "Первые 2 цифры",
    "Erste 2 Ziffern",
  ],
  addCardModal_button_complete: [
    "등록 완료",
    "Complete",
    "注册完成",
    "登録完了",
    "เสร็จสิ้น",
    "Completar",
    "Terminer",
    "Завершить",
    "Abschließen",
  ],
  checkoutModal_title: [
    "퇴실 준비 부탁드립니다",
    "Please prepare to check out",
    "请准备退房",
    "チェックアウトの準備をお願いします",
    "กรุณาเตรียมตัวเช็คเอาท์",
    "Por favor, prepárese para el check-out",
    "S'il vous plaît, préparez-vous pour le départ",
    "Пожалуйста, подготовьте выезд",
    "Bitte bereiten Sie sich auf den Check-out vor",
  ],
  checkoutModal_content_one: [
    "고객님, 편안한 밤 되셨나요?",
    "Dear customer,",
    "亲爱的顾客，您昨晚睡得好吗?",
    "お客様、快適な夜をお過ごしになりましたか?",
    "ลูกค้า, คุณนอนหลับสบายดีไหม?",
    "Estimado Cliente",
    "Cher Client",
    "Уважаемый клиент",
    "Sehr geehrter Kunde",
  ],
  checkoutModal_content_two: [
    "우리 호텔 체크아웃은 ",
    "Our hotel checkout is until ",
    "我们酒店的退房时间是上午",
    "当ホテルのチェックアウトは",
    "เวลาเช็คเอาท์ของโรงแรมเราคือก่อน ",
    "El check-out de nuestro hotel es hasta las",
    "Le départ de notre hôtel est jusqu'à",
    "Выезд из нашего отеля до",
    "Der Check-out in unserem Hotel ist bis",
  ],
  checkoutModal_content_three: [
    "까지입니다.",
    ".",
    "。",
    "までです。",
    "น.",
    ".",
    ".",
    ".",
    ".",
  ],
  checkoutModal_button_confirm: [
    "체크아웃 시간 연장하기",
    "Extend Checkout Time",
    "延长退房时间",
    "チェックアウト時間を延長する",
    "ขยายเวลาการเช็คเอาท์",
    "Ampliar el Tiempo de Salida",
    "Prolonger l'heure de départ",
    "Продлить время выезда",
    "Checkout-Zeit verlängern",
  ],
  checkoutModal_badge_event: [
    "할인 이벤트중",
    "Discount Event",
    "折扣活动中",
    "割引イベント開催中",
    "กำลังมีโปรโมชั่นส่วนลด",
    "Evento de Descuento",
    "Événement de Remise",
    "Событие со скидками",
    "Sonderaktion",
  ],
  checkoutModal_footer_one: [
    "체크아웃 연장하고",
    "Extend your checkout",
    "延长退房时间",
    "チェックアウトを延長して",
    "ขยายเวลาเช็คเอาท์",
    "¡Extiende tu check-out",
    "Prolongez votre départ",
    "Продлите время выезда",
    "Verlängern Sie den Check-out",
  ],
  checkoutModal_footer_two: [
    "여유로운 시간",
    "Enjoy",
    "享受",
    "ゆっくりとお",
    "เพลิดเพลินกับเ",
    "disfruta de",
    "profitez",
    "наслаждайтесь",
    "genießen",
  ],
  checkoutModal_footer_three: [
    "즐기세요",
    "your time",
    "悠闲时光",
    "過ごしください",
    "วลาพักผ่อน",
    "tu tiempo",
    "de votre temps",
    "своим временем",
    "Sie Ihre Zeit",
  ],

  extensionCheckoutModal_title: [
    "퇴실시간이 연장되었습니다",
    "The checkout time has been extended",
    "退房时间已延长",
    "チェックアウト時間が延長されました",
    "เวลาเช็คเอาท์ถูกขยายออกไปแล้ว",
    "La salida ha sido extendida",
    "Le départ a été prolongé",
    "Время выезда продлено",
    "Der Check-out wurde verlängert",
  ],
  extensionCheckoutModal_content_one: [
    "더 여유롭게 휴식을 즐기시고,\n새로운 퇴실 시간에 맞춰 퇴실 부탁드립니다.",
    "Please enjoy your rest at a more leisurely pace,\nand check out by the new checkout time.",
    "请更悠闲地享受您的休息，\n并请在新的退房时间前退房。",
    "どうぞゆっくりとお休みをお楽しみいただき、\n新しいチェックアウト時間に合わせて退室をお願いします。",
    "เพลิดเพลินกับการพักผ่อนอย่างสบาย ๆ\nและโปรดเช็คเอาท์ตามเวลาที่ขยายใหม่",
    "Disfruta de tu relajación extendida \ny por favor haz el check-out a la nueva hora.",
    "Profitez de votre temps de repos prolongé \net veuillez partir à la nouvelle heure de départ.",
    "Наслаждайтесь отдыхом, \nи, пожалуйста, выезжайте в новое время.",
    "Genießen Sie Ihre verlängerte Erholung \nund checken Sie bitte zur neuen Zeit aus.",
  ],
  extensionCheckoutModal_content_two: [
    "편안한 시간 보내세요!",
    "Have a relaxing time!",
    "祝您度过一个轻松的时光！",
    "ゆっくりお過ごしください！",
    "ขอให้มีช่วงเวลาที่ผ่อนคลาย!",
    "¡Que tengas un tiempo relajante!",
    "Passez un moment relaxant !",
    "Желаю вам приятного отдыха!",
    "Genießen Sie eine entspannte Zeit!",
  ],
  extensionCheckoutModal_footer_one: [
    "최소주문금액이 필요없는",
    "We have given you",
    "我们已赠送您",
    "最低注文金額なしの",
    "เราได้มอบคูปอง",
    "Se ha emitido",
    "Un coupon de 2000 wons",
    "Купон на 2000 вон",
    "Ein 2000-Won-Gutschein",
  ],
  extensionCheckoutModal_footer_two: [
    "2000원 쿠폰이 ",
    "2000원 coupon",
    "一张无需最低订单金额的",
    "2000원クーポンを",
    "2000원 ที่ไม่มียอด",
    "un cupón de 2000 won sin",
    "sans montant minimum de",
    "без минимальной суммы",
    "ohne Mindestbestellwert",
  ],
  extensionCheckoutModal_footer_three: [
    "발급되었어요",
    "with no minimum amount",
    "2000优惠券",
    "差し上げました",
    "สั่งซื้อขั้นต่ำให้คุณแล้ว",
    "cantidad mínima de pedido",
    "commande a été émis",
    "заказа был выпущен",
    "wurde ausgestellt",
  ],
  extensionCheckoutModal_footer_badge: [
    "배달 주문 시 자동적용 됩니다",
    "It will be applied to delivery orders",
    "配送订单时将自动应用",
    "配達注文時に自動適用されます",
    "จะถูกนำไปใช้เมื่อสั่งซื้อสำหรับการจัดส่ง",
    "Se aplicará al hacer un pedido de entrega",
    "Sera appliqué lors de la commande de livraison",
    "Применяется при оформлении заказа на доставку",
    "Wird bei einer Lieferbestellung angewendet",
  ],
  customer_info_modal_title: [
    "주문/예약 알림을 받으실\n 연락처를 알려주세요.",
    "Please provide the contact information where you would like to receive order/reservation notifications.",
    "请告诉我您希望接收订单/预订通知的联系信息。",
    "ご注文/予約通知を受け取るための連絡先を教えてください。",
    "กรุณาแจ้งข้อมูลการติดต่อที่ท่านต้องการให้รับการแจ้งเตือนการสั่งซื้อ/การจอง",
    "Por favor, proporcione la información de contacto donde le gustaría recibir notificaciones de pedidos/reservas.",
    "Veuillez indiquer les coordonnées où vous souhaitez recevoir des notifications de commande/réservation.",
    "Пожалуйста, укажите контактную информацию, по которой вы хотели бы получать уведомления о заказах/резервированиях.",
    "Bitte geben Sie die Kontaktdaten an, unter denen Sie Benachrichtigungen zu Bestellungen/Reservierungen erhalten möchten.",
  ],
  languageModal_lang: [
    "한국어",
    "ENGLISH",
    "中文",
    "日語",
    "ภาษาไทย",
    "español",
    "français",
    "русский",
    "Deutsche",
  ],
  customer_info_modal_kakao: [
    "카카오톡",
    "kakaoTalk",
    "kakaoTalk",
    "kakaoTalk",
    "kakaoTalk",
    "kakaoTalk",
    "kakaoTalk",
    "kakaoTalk",
    "kakaoTalk",
  ],
  cancel_notice: [
    "접수가 완료되면 취소가 불가능해요",
    "Once the order is completed, cancellation is not possible.",
    "订单完成后无法取消。",
    "受付が完了するとキャンセルはできません。",
    "ไม่สามารถยกเลิกได้เมื่อการรับคำสั่งซื้อเสร็จสิ้น",
    "Una vez que se completa el pedido, no es posible cancelarlo.",
    "Une fois la commande terminée, l'annulation n'est pas possible.",
    "После завершения заказа отмена невозможна.",
    "Sobald die Bestellung abgeschlossen ist, ist eine Stornierung nicht möglich.",
  ],
  customer_info_notice: [
    "예약 확정 시 바우처를 보내드리니, 정확한 연락처를 입력해 주세요.\n잘못된 정보 입력 시 바우처를 받을 수 없습니다.",
    "We will send you a voucher once your reservation is confirmed, so please enter the correct contact information.\nYou won't receive the voucher if incorrect information is provided.",
    "预订确认后，我们将发送使用券，请输入正确的联系方式。\n如输入错误信息，将无法收到使用券。",
    "予約確定後、バウチャーをお送りしますので、正確な連絡先を入力してください。\n間違った情報を入力した場合、バウチャーを受け取ることができません。",
    "เมื่อการจองของคุณได้รับการยืนยัน เราจะส่งบัตรกำนัลให้คุณ กรุณากรอกข้อมูลติดต่อให้ถูกต้อง\nหากกรอกข้อมูลไม่ถูกต้องจะไม่ได้รับบัตรกำนัล",
    "Le enviaremos un cupón cuando se confirme la reserva, por lo que debe ingresar la información de contacto correcta.\nNo recibirá el cupón si se ingresan datos incorrectos.",
    "Nous vous enverrons un bon une fois la réservation confirmée, alors veuillez saisir les coordonnées correctes.\nVous ne recevrez pas le bon en cas d'informations incorrectes.",
    "После подтверждения бронирования мы отправим вам ваучер, поэтому введите правильные контактные данные.\nЕсли информация введена неверно, вы не получите ваучер.",
    "Sobald Ihre Reservierung bestätigt ist, senden wir Ihnen einen Gutschein. Bitte geben Sie die richtigen Kontaktdaten ein.\nBei falschen Angaben erhalten Sie keinen Gutschein.",
  ],
  menuInfo_badge_autoConfirm: [
    "주문 즉시 확정",
    "Confirm Now",
    "立即确认",
    "即時確定",
    "ยืนยันทันที",
    "Confirmar ahora",
    "Confirmer maintenant",
    "Подтвердить",
    "Bestätigen",
  ],
  select_room_number: [
    "몇 호실 고객인가요?",
    "What is your room number?",
    "您的房间号是多少？",
    "お部屋番号は何ですか？",
    "หมายเลขห้องของคุณคืออะไร?",
    "¿Cuál es su número de habitación?",
    "Quel est votre numéro de chambre ?",
    "Какой у вас номер комнаты?",
    "Wie lautet Ihre Zimmernummer?",
  ],
  select_room_toast: [
    "투숙하시는 객실을 선택해 주세요.",
    "Please select the room you are staying in.",
    "请选择您入住的房间。",
    "ご宿泊の部屋を選択してください。",
    "กรุณาเลือกห้องที่คุณเข้าพัก",
    "Seleccione la habitación en la que se hospeda.",
    "Veuillez sélectionner la chambre dans laquelle vous séjournez.",
    "Пожалуйста, выберите номер, в котором вы проживаете.",
    "Bitte wählen Sie das Zimmer, in dem Sie übernachten.",
  ],
  qrcode_sub_notice: [
    "스캔하고 주문내역을 확인해보세요",
    "Scan to check your order details",
    "扫描查看您的订单详情",
    "スキャンして注文内容を確認してください",
    "สแกนเพื่อดูรายละเอียดการสั่งซื้อของคุณ",
    "Escanee para ver los detalles de su pedido",
    "Scannez pour vérifier les détails de votre commande",
    "Отсканируйте, чтобы проверить детали заказа",
    "Scannen Sie, um Ihre Bestelldetails zu überprüfen",
  ],
  qrcode_main_notice: [
    "QR을 스캔하지 않으면\n배달 현황을 볼 수 없어요!",
    "You can't check the delivery status without scanning the QR!",
    "不扫描二维码就无法查看配送状态！",
    "QRコードをスキャンしないと配達状況を確認できません！",
    "หากไม่สแกน QR คุณจะไม่สามารถตรวจสอบสถานะการจัดส่งได้!",
    "¡No puede ver el estado de entrega sin escanear el QR!",
    "Vous ne pouvez pas vérifier le statut de livraison sans scanner le QR !",
    "Вы не сможете проверить статус доставки без сканирования QR!",
    "Ohne das Scannen des QR-Codes können Sie den Lieferstatus nicht einsehen!",
  ],
  floor_label: [
    "층수",
    "Floor",
    "楼层",
    "階数",
    "ชั้น",
    "Piso",
    "Étage",
    "Этаж",
    "Stockwerk",
  ],
  room_label: [
    "객실",
    "Room",
    "客房",
    "客室",
    "ห้องพัก",
    "Habitación",
    "Chambre",
    "Комната",
    "Zimmer",
  ],
  menuInfo_badge_detail: [
    "상세",
    "Details",
    "详情",
    "詳細",
    "รายละเอียด",
    "Detalles",
    "Détails",
    "Детали",
    "Einzelheiten",
  ],
  contact_us: [
    "문의하기",
    "Contact us",
    "联系我们",
    "お問い合わせ",
    "ติดต่อเรา",
    "Contacto",
    "Contact",
    "Контакт",
    "Kontakt",
  ],
  contact_modal_toast_copy: [
    "이메일 주소를 복사했어요",
    "Email address copied",
    "已复制邮箱地址",
    "メールアドレスをコピーしました",
    "คัดลอกที่อยู่อีเมลแล้ว",
    "Dirección de correo copiada",
    "Adresse e-mail copiée",
    "Адрес электронной почты скопирован",
    "E-Mail-Adresse kopiert",
  ],
  contact_modal_title: [
    "고객 불만 제로 정책",
    "Zero Complaints Policy",
    "零投诉政策",
    "クレームゼロ方針",
    "นโยบายไม่มีข้อร้องเรียน",
    "Política de cero quejas",
    "Politique zéro réclamation",
    "Политика нулевых жалоб",
    "Null-Beschwerden-Politik",
  ],
  contact_modal_content: [
    "오배송/상품누락 시 100% 환불",
    "100% Refund for Wrong/Missing Items",
    "错发/缺货时全额退款",
    "誤配送/商品欠品時100％返金",
    "คืนเงิน 100% กรณีส่งผิด/สินค้าหาย",
    "Reembolso del 100% por errores/faltantes",
    "Remboursement à 100 % en cas d’erreur/produit manquant",
    "100% возврат при ошибке/недостаче",
    "100% Rückerstattung bei Fehl- oder Falschlieferung",
  ],
  customer_service_message: [
    "배달이 잘못되었거나 음식에 문제가 있다면\n아래 노크노크 고객센터에 주문전호와 불만사항을 남겨주세요",
    "If your delivery is incorrect or there is an issue with the food,\nplease leave your order number and complaint at the Knock Knock customer service below.",
    "如果您的配送错误或食物有问题，请在下面的诺克诺克客服留下您的订单号和投诉内容。",
    "配達が間違っているか、食べ物に問題がある場合は、以下のノックノックカスタマーサービスに注文番号と苦情を残してください。",
    "หากการจัดส่งผิดหรือมีปัญหากับอาหาร โปรดทิ้งหมายเลขคำสั่งซื้อและข้อร้องเรียนของคุณที่ศูนย์บริการลูกค้าโน้กโน้กด้านล่าง",
    "Si su entrega es incorrecta o hay un problema con la comida,\ndeje su número de pedido y queja en el servicio al cliente de Knock Knock a continuación.",
    "Si votre livraison est incorrecte ou si vous avez un problème avec la nourriture,\nveuillez laisser votre numéro de commande et votre plainte au service client Knock Knock ci-dessous.",
    "Если доставка неверна или есть проблема с едой,\nпожалуйста, оставьте свой номер заказа и жалобу в службе поддержки клиентов Knock Knock ниже.",
    "Wenn die Lieferung falsch ist oder es ein Problem mit dem Essen gibt,\nhinterlassen Sie bitte Ihre Bestellnummer und Beschwerde beim Kundenservice von Knock Knock unten.",
  ],
  contact_modal_kakaotalk: [
    "카카오톡\n바로가기",
    "KakaoTalk\nShortcut",
    "KakaoTalk\n快捷方式",
    "カカオトーク\nショートカット",
    "KakaoTalk\nทางลัด",
    "KakaoTalk\nAcceso directo",
    "KakaoTalk\nRaccourci",
    "KakaoTalk\nЯрлык",
    "KakaoTalk\nVerknüpfung",
  ],
  contact_modal_footer: [
    "* 음식 관련 문의는 주문하신 매장에 연락하시면 빠르게 해결돼요",
    "* For food issues, contact the store",
    "* 食品问题请联系商店",
    "* 食品については店舗に連絡を",
    "* คำถามเรื่องอาหาร ติดต่อร้านได้เลย",
    "* Para temas de comida, contacte la tienda",
    "* Pour questions nourriture, contactez le magasin",
    "* По вопросам еды, обращайтесь в магазин",
    "* Bei Fragen zum Essen, Geschäft kontaktieren",
  ],

  restaurants_near_the_hotel: [
    "호텔 주변 맛집 쿠폰",
    "Restaurants near the hotel coupon",
    "酒店附近的餐厅优惠券",
    "ホテル周辺のグルメ・レストランクーポン",
    "ร้านอาหารใกล้โรงแรมคูปอง",
    "Restaurantes cerca del hotel cupón",
    "Restaurants à proximité de l'hôtel coupon",
    "Рестораны рядом с отелем купон",
    "Restaurants in der Nähe des Hotels Coupon",
  ],
  coupon_contact_request: [
    "쿠폰을 받으실 \n연락처를 입력해주세요",
    "Please enter your contact information to receive the coupon",
    "请输入您的联系方式以领取优惠券",
    "クーポンを受け取るための連絡先を入力してください",
    "กรุณากรอกข้อมูลติดต่อของคุณเพื่อรับคูปอง",
    "Por favor ingrese su información de contacto para recibir el cupón",
    "Veuillez entrer vos coordonnées pour recevoir le coupon",
    "Пожалуйста, введите свои контактные данные, чтобы получить купон",
    "Bitte geben Sie Ihre Kontaktdaten ein, um den Gutschein zu erhalten",
  ],
  category: [
    "카테고리",
    "Category",
    "分类",
    "カテゴリー",
    "หมวดหมู่",
    "Categoría",
    "Catégorie",
    "Категория",
    "Kategorie",
  ],
  slider_checkin_coupon: [
    "체크인 시 받으신 쿠폰을 등록하고 할인받으세요",
    "Register your check-in coupon",
    "登记入住优惠券",
    "チェックインクーポンを登録してください",
    "ลงทะเบียนคูปองเช็คอิน",
    "Registra tu cupón de check-in",
    "Enregistrez votre coupon de check-in",
    "Зарегистрируйте купон при заезде",
    "Check-in-Gutschein registrieren",
  ],
  slider_christmas_coupon: [
    "선물상자 고르기 게임에 참여하고 할인 받으세요",
    "Pick a box and get a coupon",
    "参与随机盒子游戏领取优惠券",
    "ランダムボックスゲームでクーポンをゲット",
    "เข้าร่วมเกมกล่องสุ่มและรับคูปอง",
    "Elige una caja y obtén un cupón",
    "Choisissez boîte, recevez coupon",
    "Выберите коробку и получите купон",
    "Box wählen, Gutschein holen!",
  ],
  coupon_already: [
    "쿠폰을 이미 발급받았어요",
    "Coupon already issued",
    "优惠券已领取",
    "クーポンは既に発行済みです",
    "รับคูปองแล้ว",
    "Cupón ya emitido",
    "Coupon déjà émis",
    "Купон уже выдан",
    "Gutschein bereits ausgestellt",
  ],
  christmas_event_title: [
    "산타의 선물상자!",
    "Santa's Gift Box!",
    "圣诞老人的礼物盒！",
    "サンタのギフトボックス！",
    "กล่องของขวัญของซานต้า!",
    "¡La caja de regalos de Santa!",
    "La boîte à cadeaux du Père Noël !",
    "Подарочная коробка Санты!",
    "Santas Geschenkkiste!",
  ],
  christmas_event_subtitle: [
    "5,000원 쿠폰을 찾아라",
    "Find the 5,000 won coupon",
    "寻找5,000韩元优惠券",
    "5,000円クーポンを探せ",
    "ค้นหาคูปอง 5,000 วอน",
    "Encuentra el cupón de 5,000 wones",
    "Trouvez le coupon de 5 000 wons",
    "Найдите купон на 5,000 вон",
    "Finden Sie den 5.000-Won-Gutschein",
  ],
  coupon_won: [
    "당첨!",
    "Won!",
    "中！",
    "当！",
    "ถูกรางวัล!",
    "¡Ganado!",
    "Gagné !",
    "Выигрыш!",
    "Gewonnen!",
  ],
  christmas_event_comment: [
    "올 한해 노크노크를 사랑해주신 감사의 마음을 담아\n특별한 선물을 준비했어요",
    "Thank you for loving Knock Knock.\nHere’s a special gift for you.",
    "感谢您喜爱Knock Knock。\n我们为您准备了特别的礼物。",
    "ノックノックを愛してくださる皆様に感謝して\n特別なギフトを用意しました。",
    "ขอบคุณที่รัก Knock Knock\nเราเตรียมของขวัญพิเศษไว้ให้คุณ",
    "Gracias por amar Knock Knock.\nTe damos un regalo especial.",
    "Merci d'aimer Knock Knock.\nVoici un cadeau spécial pour vous.",
    "Спасибо, что любите Knock Knock.\nВот особый подарок для вас.",
    "Danke, dass Sie Knock Knock lieben.\nHier ist ein besonderes Geschenk für Sie.",
  ],
  christmas_event_comment_footer: [
    "두근두근 선물상자를 열고\n행운의 주인공이 되어보세요!",
    "Open the gift box\nand get your luck!",
    "打开礼物盒\n成为幸运的主人公吧！",
    "ギフトボックスを開けて\n幸運の主人公になりましょう！",
    "เปิดกล่องของขวัญ\nและรับโชคของคุณ!",
    "¡Abre la caja de regalos\ny consigue tu suerte!",
    "Ouvrez la boîte cadeau\net obtenez votre chance !",
    "Откройте подарочную коробку\nи получите свою удачу!",
    "Öffnen Sie die Geschenkbox\nund holen Sie sich Ihr Glück!",
  ],
  christmas_event_coupon_comment: [
    "메뉴를 담으면 장바구니에서 자동으로 할인이 적용돼요",
    "The discount will be automatically applied in the cart",
    "将商品加入购物车，折扣会自动应用",
    "メニューをカートに入れると、自動的に割引が適用されます",
    "เมื่อใส่เมนูลงในตะกร้า ส่วนลดจะถูกนำไปใช้โดยอัตโนมัติ",
    "El descuento se aplicará automáticamente en el carrito",
    "La remise sera automatiquement appliquée dans le panier",
    "Скидка будет автоматически применена в корзине",
    "Rabatt wird automatisch im Warenkorb angewendet",
  ],
  christmas_event_coupon_button: [
    "주문하러가기",
    "Go to order",
    "去下单",
    "注文する",
    "ไปสั่งซื้อ",
    "Ir a ordenar",
    "Aller commander",
    "Перейти к заказу",
    "Zur Bestellung",
  ],
  get_coupon: [
    "쿠폰 받기",
    "Get Coupon",
    "領取優惠券",
    "クーポンを受け取る",
    "รับคูปอง",
    "Obtener Cupón",
    "Obtenir un Coupon",
    "Получить купон",
    "Gutschein erhalten",
  ],
  coupon_issued: [
    "이미 발급된 할인권이 존재합니다.",
    "A discount coupon has already been issued.",
    "已存在已發行的折扣券。",
    "既に発行された割引券が存在します。",
    "มีคูปองส่วนลดที่ออกแล้ว",
    "Ya existe un cupón de descuento emitido.",
    "Un coupon de réduction a déjà été émis.",
    "Уже существует выданный купон на скидку.",
    "Ein bereits ausgestellter Rabattgutschein ist vorhanden.",
  ],
  coupon_none: [
    "유효하지 않은 할인권입니다.",
    "This is an invalid discount coupon.",
    "這是一張無效的折扣券。",
    "無効な割引券です。",
    "นี่คือคูปองส่วนลดที่ไม่ถูกต้อง",
    "Este es un cupón de descuento no válido.",
    "Ceci est un coupon de réduction invalide.",
    "Это недействительный купон на скидку.",
    "Dies ist ein ungültiger Rabattgutschein.",
  ],
  coupon_expired: [
    "사용기한이 지난 할인권입니다.",
    "This discount coupon has expired.",
    "此折扣券已過期。",
    "有効期限が切れた割引券です。",
    "คูปองส่วนลดนี้หมดอายุแล้ว",
    "Este cupón de descuento ha expirado.",
    "Ce coupon de réduction est expiré.",
    "Этот купон на скидку истёк.",
    "Dieser Rabattgutschein ist abgelaufen.",
  ],
  send_coupon: [
    "쿠폰이 발송되었습니다.",
    "The coupon has been sent.",
    "優惠券已發送。",
    "クーポンが送信されました。",
    "คูปองถูกส่งแล้ว",
    "El cupón ha sido enviado.",
    "Le coupon a été envoyé.",
    "Купон был отправлен.",
    "Der Gutschein wurde versendet.",
  ],
  game_start: [
    "게임 시작하기",
    "Start Game",
    "Start Game",
    "Start Game",
    "Start Game",
    "Start Game",
    "Start Game",
    "Start Game",
    "Start Game",
  ],
  find_item_title: [
    "다른 그림 하나를 \n찾아보세요",
    "Look for \nanother picture",
    "Look for \nanother picture",
    "Look for \nanother picture",
    "Look for \nanother picture",
    "Look for \nanother picture",
    "Look for \nanother picture",
    "Look for \nanother picture",
    "Look for \nanother picture",
  ],
  time_left: [
    "남은시간",
    "Time left",
    "Time left",
    "Time left",
    "Time left",
    "Time left",
    "Time left",
    "Time left",
    "Time left",
  ],
  payment_ready: [
    "결제가 진행중입니다\n잠시만 기다려주세요",
    "The payment is being processed\nPlease wait a moment",
    "付款正在进行中\n请稍等",
    "お支払いを処理しています\n少々お待ちください",
    "กำลังดำเนินการชำระเงิน\nโปรดรอสักครู่",
    "El pago se está procesando\nPor favor espera un momento",
    "Le paiement est en cours\nVeuillez patienter un moment",
    "Платеж обрабатывается\nПожалуйста, подождите",
    "Die Zahlung wird bearbeitet\nBitte warten Sie einen Moment",
  ],
  get_findItem_coupon: [
    "할인쿠폰이 발급되었어요",
    "A discount coupon has been issued.",
    "折扣券已發放。",
    "割引クーポンが発行されました。",
    "คูปองส่วนลดได้ถูกออกแล้ว",
    "Se ha emitido un cupón de descuento.",
    "Un coupon de réduction a été émis.",
    "Скидочный купон был выпущен.",
    "Ein Rabattgutschein wurde ausgestellt.",
  ],
  wrong_game: [
    "틀렸어요",
    "That's incorrect",
    "That's incorrect",
    "That's incorrect",
    "That's incorrect",
    "That's incorrect",
    "That's incorrect",
    "That's incorrect",
    "That's incorrect",
  ],
  try_again_game: [
    "다음에 다시 도전하세요",
    "Try again next time",
    "Try again next time",
    "Try again next time",
    "Try again next time",
    "Try again next time",
    "Try again next time",
    "Try again next time",
    "Try again next time",
  ],
  game_correct: [
    "정답이에요",
    "That's correct",
    "That's correct",
    "That's correct",
    "That's correct",
    "That's correct",
    "That's correct",
    "That's correct",
    "That's correct",
  ],
  next_game: [
    "다음단계로 넘어가요",
    "Proceed to the next level",
    "Proceed to the next level",
    "Proceed to the next level",
    "Proceed to the next level",
    "Proceed to the next level",
    "Proceed to the next level",
    "Proceed to the next level",
    "Proceed to the next level",
  ],
  payment_not_minimum: [
    "500원 이상부터 결제 가능해요",
    "Payment is available from 500 KRW",
    "500韩元以上可支付",
    "500ウォン以上からお支払い可能です",
    "สามารถชำระเงินได้ตั้งแต่ 500 วอนขึ้นไป",
    "El pago está disponible desde 500 KRW",
    "Le paiement est disponible à partir de 500 KRW",
    "Оплата доступна от 500 KRW",
    "Zahlung ist ab 500 KRW möglich",
  ],
  payment_error: [
    "결제 에러",
    "Payment Error",
    "支付错误",
    "支払いエラー",
    "ข้อผิดพลาดการชำระเงิน",
    "Error de pago",
    "Erreur de paiement",
    "Ошибка платежа",
    "Zahlungsfehler",
  ],
  payment_title_pay: [
    "결제하기",
    "Pay",
    "支付",
    "支払い",
    "จ่าย",
    "Pagar",
    "Payer",
    "Оплатить",
    "Bezahlen",
  ],
};

Object.freeze(langText);
